document.addEventListener("DOMContentLoaded", (event) => {
  const url = new URL(window.location.href);
  const cartDrawerOpen = url.searchParams.get('cart_drawer_open') === 'true';
  var cartDrawer = document.querySelector('m-cart-drawer');
  if (cartDrawer && cartDrawerOpen) { 
    cartDrawer.open();
    url.searchParams.delete('cart_drawer_open');
    window.history.replaceState({}, '', url);
  }
});

MinimogTheme.pubSubEvents = {
  cartError: "cart-error",
  cartUpdate: "cart-update",
  openCartDrawer: "open-cart-drawer",
  openSearchPopup: "open-search-popup",
  closeSearchPopup: "close-search-popup",
};
const requestDefaultConfigs = {
  mode: "same-origin",
  credentials: "same-origin",
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "Content-Type": "application/json",
  },
};
((MinimogTheme.config = {
  mqlMobile: !1,
  mqlTablet: !1,
  mediaQueryMobile: "screen and (max-width: 767px)",
  mediaQueryTablet: "screen and (max-width: 1023px",
}),
  (MinimogTheme.initWhenVisible = function (e) {
    let t = e.threshold ? e.threshold : 0;
    new IntersectionObserver(
      (t, i) => {
        t.forEach((t) => {
          t.isIntersecting && "function" == typeof e.callback && (e.callback(), i.unobserve(t.target));
        });
      },
      {
        rootMargin: `0px 0px ${t}px 0px`,
      },
    ).observe(e.element);
  }),
  (function () {
    let e = window.matchMedia(MinimogTheme.config.mediaQueryMobile);
    ((MinimogTheme.config.mqlMobile = e.matches),
      (e.onchange = (e) => {
        e.matches ? ((MinimogTheme.config.mqlMobile = !0), document.dispatchEvent(new CustomEvent("matchMobile"))) : ((MinimogTheme.config.mqlMobile = !1), document.dispatchEvent(new CustomEvent("unmatchMobile")));
      }));
    let t = window.matchMedia(MinimogTheme.config.mediaQueryTablet);
    ((MinimogTheme.config.mqlTablet = t.matches),
      (t.onchange = (e) => {
        e.matches ? ((MinimogTheme.config.mqlTablet = !0), document.dispatchEvent(new CustomEvent("matchTablet"))) : ((MinimogTheme.config.mqlTablet = !1), document.dispatchEvent(new CustomEvent("unmatchTablet")));
      }));
    var i = document.querySelector(".m-page-transition");
    !(function () {
      if (!window.AnimationEvent || !i) return;
      let e = !1,
        t = "true" === i.dataset.designMode;
      (document.querySelectorAll("a[href^=mailto], a[href^=tel]").forEach((t) => {
        t.addEventListener("click", () => {
          e = !0;
        });
      }),
        t && Shopify.designMode
          ? i.classList.add("m-page-transition--design-mode")
          : (window.addEventListener("beforeunload", () => {
              e || i.classList.add("fade-in");
            }),
            window.addEventListener("DOMContentLoaded", () => {
              (document.documentElement.classList.remove("m:overflow-hidden"),
                document.body.classList.remove("m:overflow-hidden"),
                setScrollbarWidth(),
                setTimeout(() => {
                  i.classList.add("fade-out");
                }, 300),
                document.dispatchEvent(new CustomEvent("page:loaded")));
            }),
            window.addEventListener("pageshow", (e) => {
              e.persisted && i.classList.remove("fade-in");
            })));
    })();
  })());
class CountdownTimer {
  constructor(e, t, i, s = {}) {
    ((this.times = ["day", "hour", "min", "sec"]),
      (this.selectors = {
        day: ".countdown-timer-day",
        hour: ".countdown-timer-hour",
        min: ".countdown-timer-minute",
        sec: ".countdown-timer-sec",
      }),
      (this.DAY_IN_MS = 864e5),
      (this.HOUR_IN_MS = 36e5),
      (this.MIN_IN_MS = 6e4),
      (this.container = e),
      (this.startTime = t),
      (this.savedStartTime = t),
      (this.endTime = i),
      (this.options = Object.assign(
        {},
        {
          addZeroPrefix: !0,
          loop: !1,
          callback() {},
        },
        s,
      )),
      (this.intervalTime = 1e3),
      (this.timer = null),
      (this.domNodes = queryDomNodes(this.selectors, e)),
      this.start());
  }
  start() {
    ((this.timer = setInterval(() => {
      this.startTime > this.endTime ? this.stop() : this.update();
    }, this.intervalTime)),
      this.container.style.removeProperty("opacity"));
  }
  update() {
    let e = this.format(this.endTime - this.startTime);
    (this.times.forEach((t) => {
      this.domNodes[t] && (this.domNodes[t].textContent = this.addZeroPrefix(e[t]));
    }),
      (this.startTime += this.intervalTime));
  }
  stop() {
    (clearInterval(this.timer), this.options.loop ? ((this.startTime = this.savedStartTime), this.start()) : ((this.timer = null), this.options.callback()));
  }
  clear() {
    (clearInterval(this.timer),
      (this.timer = null),
      (this.startTime = this.savedStartTime),
      this.times.forEach((e) => {
        this.domNodes[e] && (this.domNodes[e].textContent = "00");
      }));
  }
  addZeroPrefix(e) {
    return this.options.addZeroPrefix && e < 10 ? `0${e}` : e.toString();
  }
  format(e) {
    return {
      day: Math.floor(e / this.DAY_IN_MS),
      hour: Math.floor(e / this.HOUR_IN_MS) % 24,
      min: Math.floor(e / this.MIN_IN_MS) % 60,
      sec: Math.floor(e / 1e3) % 60,
    };
  }
}
window.MinimogTheme.CountdownTimer = CountdownTimer;
class Tabs {
  constructor(e, t = () => {}) {
    ((this.selectors = {
      tabHeaders: [".m-tab-header"],
      tabContents: [".m-tab-content"],
    }),
      (this.activeClass = "active"),
      (this.currentActiveIndex = -1),
      (this.currentTab = null),
      (this.container = e),
      (this.cb = t),
      (this.domNodes = queryDomNodes(this.selectors, e)),
      (this.customSelect = this.container.querySelector("m-select-component")),
      this.init(),
      this.setActiveTab(0));
  }
  init() {
    addEventDelegate({
      context: this.container,
      selector: this.selectors.tabHeaders[0],
      handler: (e, t) => {
        let i;
        (e.preventDefault(), t && (i = Number(t.dataset.index)), this.setActiveTab(i), this.cb(t));
      },
    });
  }
  setActiveTab(e) {
    let { tabHeaders: t, tabContents: i } = this.domNodes;
    if (i.length && -1 !== e && this.currentActiveIndex !== e) {
      let s, n, o;
      ((s = t && t[this.currentActiveIndex]),
        (n = t && t[e]),
        this.customSelect && n && ("select" === this.customSelect.dataset.tabHeader && this.customSelect.updateCustomSelectChecked(e, n.innerHTML), MinimogTheme.config.mqlMobile && this.customSelect.updateCustomSelectChecked(e, n.innerHTML), document.addEventListener("matchMobile", () => this.customSelect.updateCustomSelectChecked(e, n.innerHTML))),
        (o = i && i[e]),
        s && s.classList.remove(this.activeClass),
        this.currentTab && this.currentTab.classList.remove(this.activeClass),
        n && n.classList.add(this.activeClass),
        o && o.classList.add(this.activeClass),
        setTimeout(() => (o.style.opacity = 1)),
        (this.currentActiveIndex = e),
        (this.currentTab = o));
    }
  }
}

function setScrollbarWidth() {
  document.documentElement.style.setProperty("--m-scrollbar-width", window.innerWidth - document.documentElement.clientWidth + "px");
}

function isStorageSupported(e) {
  if (window.self !== window.top) return !1;
  let t = "minimog:check",
    i;
  ("session" === e && (i = window.sessionStorage), "local" === e && (i = window.localStorage));
  try {
    return (i.setItem(t, "1"), i.removeItem(t), !0);
  } catch (s) {
    return !1;
  }
}

function getFocusableElements(e) {
  return Array.from(e.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
((window.MinimogTheme.Tabs = Tabs),
  void 0 === window.Shopify && (window.Shopify = {}),
  (Shopify.bind = function (e, t) {
    return function () {
      return e.apply(t, arguments);
    };
  }),
  (Shopify.setSelectorByValue = function (e, t) {
    for (var i = 0, s = e.options.length; i < s; i++) {
      var n = e.options[i];
      if (t == n.value || t == n.innerHTML) return ((e.selectedIndex = i), i);
    }
  }),
  (Shopify.addListener = function (e, t, i) {
    e.addEventListener ? e.addEventListener(t, i, !1) : e.attachEvent("on" + t, i);
  }),
  (Shopify.CountryProvinceSelector = function (e, t, i) {
    ((this.countryEl = document.getElementById(e)), (this.provinceEl = document.getElementById(t)), (this.provinceContainer = document.getElementById(i.hideElement || t)), Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)), this.initCountry(), this.initProvince());
  }),
  (Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
      var e = this.countryEl.getAttribute("data-default");
      (Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler());
    },
    initProvince: function () {
      var e = this.provinceEl.getAttribute("data-default");
      e && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, e);
    },
    countryHandler: function (e) {
      var t = JSON.parse((i = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces"));
      if ((this.clearOptions(this.provinceEl), t && 0 == t.length)) this.provinceContainer.style.display = "none";
      else {
        for (var i, s = 0; s < t.length; s++) (((i = document.createElement("option")).value = t[s][0]), (i.innerHTML = t[s][1]), this.provinceEl.appendChild(i));
        this.provinceContainer.style.display = "";
      }
    },
    clearOptions: function (e) {
      for (; e.firstChild; ) e.removeChild(e.firstChild);
    },
    setOptions: function (e, t) {
      var i = 0;
      for (t.length; i < t.length; i++) {
        var s = document.createElement("option");
        ((s.value = t[i]), (s.innerHTML = t[i]), e.appendChild(s));
      }
    },
  }),
  setScrollbarWidth());
const trapFocusHandlers = {};

function trapFocus(e, t = e) {
  var i = getFocusableElements(e),
    s = i[0],
    n = i[i.length - 1];
  (removeTrapFocus(),
    (trapFocusHandlers.focusin = (t) => {
      (t.target !== e && t.target !== n && t.target !== s) || document.addEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.focusout = function () {
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.keydown = function (t) {
      "TAB" !== t.code.toUpperCase() || (t.target !== n || t.shiftKey || (t.preventDefault(), s.focus()), (t.target === e || t.target === s) && t.shiftKey && (t.preventDefault(), n.focus()));
    }),
    document.addEventListener("focusout", trapFocusHandlers.focusout),
    document.addEventListener("focusin", trapFocusHandlers.focusin),
    t.focus(),
    "INPUT" === t.tagName && ["search", "text", "email", "url"].includes(t.type) && t.value && t.setSelectionRange(0, t.value.length));
}

function removeTrapFocus(e = null) {
  (document.removeEventListener("focusin", trapFocusHandlers.focusin), document.removeEventListener("focusout", trapFocusHandlers.focusout), document.removeEventListener("keydown", trapFocusHandlers.keydown), e && e.focus());
}

function getRequestDefaultConfigs() {
  return JSON.parse(JSON.stringify(requestDefaultConfigs));
}

function fetchJSON(e, t = getRequestDefaultConfigs()) {
  return fetch(e, t).then(function (e) {
    if (!e.ok) throw e;
    return e.json();
  });
}
const cache = new Map();

function fetchCache(e, t = getRequestDefaultConfigs()) {
  return new Promise((i, s) => {
    let n = cache.get(e);
    if (n) return i(n);
    fetch(e, t)
      .then((t) => {
        ((n = t.text()), cache.set(e, n), i(n));
      })
      .catch(s);
  });
}
const sectionCache = new Map();

function fetchSection(e, t = {}) {
  let { url: i, fromCache: s = !1, params: n = {} } = t;
  return new Promise((t, o) => {
    let r = new URL(i || window.location.href);
    if ((r.searchParams.set("section_id", e), Object.entries(n).forEach(([e, t]) => r.searchParams.set(e, t)), s)) {
      let a = sectionCache.get(r);
      if (a) return t(a);
    }
    fetch(r, getRequestDefaultConfigs())
      .then((t) => {
        if (t.ok) return t.text();
        o(`Failed to load section: ${e}`);
      })
      .then((e) => {
        let i = generateDomFromString(e);
        (sectionCache.set(r, i), t(i));
      })
      .catch(o);
  });
}
const cache2 = new Map();

function fetchJsonCache(e, t = requestDefaultConfigs) {
  return new Promise((i, s) => {
    if (cache2.get(e)) return i(cache2.get(e));
    fetch(e, t)
      .then((t) => {
        if (t.ok) {
          let n = t.json();
          return (i(n), cache2.set(e, n), n);
        }
        s(t);
      })
      .catch(s);
  });
}

function formatMoney(e, t) {
  "string" == typeof e && (e = e.replace(".", ""));
  let i = "",
    s = /\{\{\s*(\w+)\s*\}\}/,
    n = t || "${{amount}}";

  function o(e, t = 2, i = ",", s = ".") {
    if (isNaN(e) || null == e) return 0;
    let n = (e = (e / 100).toFixed(t)).split(".");
    return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${i}`) + (n[1] ? s + n[1] : "");
  }
  switch (n.match(s)[1]) {
    case "amount":
      i = o(e, 2);
      break;
    case "amount_no_decimals":
      i = o(e, 0);
      break;
    case "amount_with_comma_separator":
      i = o(e, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      i = o(e, 0, ".", ",");
  }
  return n.replace(s, i);
}

function validateForm(e) {
  let t = [];
  return (
    e &&
      e.querySelectorAll('[data-product-custom-field] [name][required]:not([hidden]):not([type="hidden"])').forEach((i) => {
        if ((i.classList.remove("form-control--warning"), "radio" === i.type)) {
          let s = e.querySelectorAll(`input[name="${i.name}"]`);
          Array.from(s).some((e) => e.checked) || (t.push(i), i.classList.add("form-control--warning"));
        } else i.value || (t.push(i), i.classList.add("form-control--warning"));
      }),
    t
  );
}

function generateDomFromString(e, t = "div") {
  let i = document.createElement(t);
  return ((i.innerHTML = e), i);
}

function generateDomeFromStringNew(e, t = "div") {
  return new DOMParser().parseFromString(e, "text/html").querySelector(t);
}

function fetchCountDown(e) {
  let t = MinimogSettings.foxKitBaseUrl ? `https://${MinimogSettings.foxKitBaseUrl}` : "";
  return new Promise((i, s) => {
    fetch(`${t}/api/public/countdown?shop=${window.Shopify.shop}&collectionIds=${e}`)
      .then((e) => e.json())
      .then(i)
      .catch(s);
  });
}

function loadAssetsNew(e = [], t, i = () => {}, s = {}) {
  let n = t || Math.random().toString(36).slice(2);
  (window.MinimogLibs.loadjs.isDefined(t) || window.MinimogLibs.loadjs(e, n), window.MinimogLibs.loadjs.ready(n, i));
}

function pauseAllMedia(e = document) {
  (e.querySelectorAll(".js-youtube").forEach((e) => {
    e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
  }),
    e.querySelectorAll(".js-vimeo").forEach((e) => {
      e.contentWindow.postMessage('{"method":"pause"}', "*");
    }),
    e.querySelectorAll("video").forEach((e) => e.pause()),
    e.querySelectorAll("product-model").forEach((e) => {
      e.modelViewerUI && e.modelViewerUI.pause();
    }));
}

function loadJS(e, t = document.body, i = !1, s = !0) {
  return new Promise((n, o) => {
    let r = t.ownerDocument,
      a = r.querySelector(`script[src="${e}"]`);
    if (a)
      return a.dataset.loaded
        ? n(!0)
        : void a.addEventListener("load", () => {
            ((a.dataset.loaded = !0), n(!0));
          });
    let l = r.createElement("script");
    ((l.src = e),
      (l.async = i),
      (l.defer = s),
      l.addEventListener("load", () => {
        ((l.dataset.loaded = !0), n(!0));
      }),
      (l.onerror = o),
      t.appendChild(l));
  });
}

function loadCSS(e, t = document.head) {
  return new Promise((i, s) => {
    let n = t.ownerDocument,
      o = n.querySelector(`link[href="${e}"]`);
    if (o)
      return o.dataset.loaded
        ? i(!0)
        : void o.addEventListener("load", () => {
            ((o.dataset.loaded = !0), i(!0));
          });
    let r = n.createElement("link");
    ((r.rel = "stylesheet"),
      (r.href = e),
      r.addEventListener("load", () => {
        ((r.dataset.loaded = !0), i(!0));
      }),
      (r.onerror = s),
      t.appendChild(r));
  });
}

function addEventDelegate({ context: e = document.documentElement, event: t = "click", selector: i, handler: s, capture: n = !1 }) {
  let o = function (e) {
    for (let t = e.target; t && t !== this; t = t.parentNode)
      if (t.matches(i)) {
        s.call(t, e, t);
        break;
      }
  };
  return (
    e.addEventListener(t, o, n),
    () => {
      e.removeEventListener(t, o, n);
    }
  );
}

function debounce(e, t) {
  let i;
  return (...s) => {
    (clearTimeout(i), (i = setTimeout(() => e.apply(this, s), t)));
  };
}

function _validateOptionsArray(e) {
  if (Array.isArray(e) && "object" == typeof e[0]) throw Error(e + "is not a valid array of options.");
}

function _validateProductStructure(e) {
  if ("object" != typeof e) throw TypeError(e + " is not an object.");
  if (0 === Object.keys(e).length && e.constructor === Object) throw Error(e + " is empty.");
}

function getVariantFromOptionArray(e, t) {
  return (
    _validateProductStructure(e),
    _validateOptionsArray(t),
    e.variants.filter(function (e) {
      return t.every(function (t, i) {
        return e.options[i] === t;
      });
    })[0] || null
  );
}

function getSizedImageUrl(e, t) {
  if (null === t) return e;
  if ("master" === t) return removeProtocol(e);
  var i = e.match(/\.(jpg|jpeg|gif|png|webp|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
  if (i) {
    var s = e.split(i[0]),
      n = i[0];
    return removeProtocol(s[0] + "_" + t + n);
  }
  return null;
}

function removeProtocol(e) {
  return e.replace(/http(s)?:/, "");
}

function updateParam(e, t) {
  var { location: i } = window,
    s = [i.protocol, "//", i.host, i.pathname].join("");
  let n = window.location.search,
    o = new URLSearchParams(n);
  return (o.has(e) ? ("" !== t && "undefined" !== t && o.set(e, t), ("" !== t && "undefined" !== t) || o.delete(e)) : t && o.append(e, t), window.history.replaceState({}, "", s + "?" + o.toString()), !1);
}

function createSearchLink(e) {
  let t = new URLSearchParams({
    type: "product",
    "options[unavailable_products]": "last",
    "options[prefix]": "last",
    q: e,
  });
  return `${window.MinimogSettings.routes.search_url}?${t.toString()}`;
}

function refreshProductReview() {
  if (("undefined" != typeof SMARTIFYAPPS && SMARTIFYAPPS.rv.installed && SMARTIFYAPPS.rv.scmReviewsRate.actionCreateReviews(), "undefined" != typeof Yotpo && "function" == typeof Yotpo.API)) {
    let e = new Yotpo.API(yotpo);
    e?.refreshWidgets();
  }
}

function queryDomNodes(e = {}, t = document) {
  return Object.entries(e).reduce((e, [i, s]) => {
    let n = "string" == typeof s,
      o = n ? s : s[0];
    return (t && (e[i] = t[n ? "querySelector" : "querySelectorAll"](o)), !n && e[i] && (e[i] = [...e[i]]), e);
  }, {});
}

function saleProgress(e, t, i) {
  let { total_quantity: s, sold_to: n, sold_from: o } = e,
    r;
  if (i) r = parseInt(i);
  else {
    let a = 4 / 24 + (Number(t.split("").pop()) + 1) / 10;
    (a > 1 && (a -= 1), (r = o + Math.ceil(a * (n - o))));
  }
  let l = s - r;
  return `<div class="m-product-sale-progress"><div class="m-product-sale-progress__bar" data-flash-sale><span data-sale-progress style="width: ${(100 * r) / s}%;" /></div><div class="m-product-sale-progress__text"><div><span>${MinimogStrings.sold}: </span><strong data-sale-number>${r || 0}</strong></div><div><span>${MinimogStrings.available}: </span><strong data-available-number>${l || 0}</strong></div></div></div>`;
}

function spinner(e = "") {
  return `<svg class="animate-spin m:hidden m-svg-icon--medium ${e}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>`;
}

function fetchConfig(e = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${e}`,
    },
  };
}

function setCookie(e, t, i) {
  var s = new Date();
  s.setTime(s.getTime() + 24 * i * 36e5);
  var n = "expires=" + s.toUTCString();
  document.cookie = e + "=" + t + ";" + n + ";path=/";
}

function getCookie(e) {
  for (var t = e + "=", i = decodeURIComponent(document.cookie).split(";"), s = 0; s < i.length; s++) {
    for (var n = i[s]; " " === n.charAt(0); ) n = n.substring(1);
    if (0 === n.indexOf(t)) return n.substring(t.length, n.length);
  }
  return "";
}

function formatUrl(e, t, i) {
  let s,
    { routes: n } = MinimogSettings;
  return ((s = `${n.root.endsWith("/") ? "" : n.root}/${e}/${t}`), i && (s += `?${i}`), s);
}
!(function () {
  let e = document.querySelectorAll("[data-ps-item]");
  e && e.forEach((e) => (e.href = createSearchLink(e.dataset.psQuery)));
})();
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    let e = this.querySelector('[id*="Deferred-Poster-"]');
    e && e.addEventListener("click", this.loadContent.bind(this));
  }
  loadContent(e = !0) {
    if (!this.getAttribute("loaded")) {
      let t = document.createElement("div");
      (t.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)), this.setAttribute("loaded", !0));
      let i = this.appendChild(t.querySelector("video, model-viewer, iframe"));
      ((this.deferredElement = i), e && i.focus(), this.playVideo(i));
    }
  }
  playVideo(e) {
    if (!this.autoPlay) {
      if (e.classList.contains("js-youtube")) {
        let t = e.src.indexOf("?") > -1 ? "&" : "?";
        e.src += t + "autoplay=1&mute=1";
      } else if (e.classList.contains("js-vimeo")) {
        let i = e.src.indexOf("?") > -1 ? "&" : "?";
        e.src += i + "autoplay=1&muted=1";
      } else (e && e.setAttribute("autoplay", "autoplay"), e && e.play());
    }
  }
}
customElements.define("deferred-media", DeferredMedia);
class ResponsiveImage extends HTMLElement {
  get intersecting() {
    return this.hasAttribute("intersecting");
  }
  constructor() {
    (super(), (this.img = this.querySelector("img")), (this.src = this.img.src), (this.observerCallback = this.observerCallback.bind(this)), this.img && ((this.loadImage = this.loadImage.bind(this)), (this.img.onload = this.onLoad.bind(this))), this.img.complete && this.onLoad());
  }
  connectedCallback() {
    "IntersectionObserver" in window ? this.initIntersectionObserver() : this.loadImage();
  }
  disconnectedCallback() {
    this.disconnectObserver();
  }
  loadImage() {
    // this.setAttribute("intersecting", "true"), this.img && (this.img.src = this.src, this.img.width = this.clientWidth, this.img.height = this.clientHeight, this.img.sizes = this.clientWidth + "px"), window.MinimogEvents.emit("m:image-loaded", this.imageLoaded, this)
    (this.setAttribute("intersecting", "true"), this.img && ((this.img.src = this.src), (this.img.width = this.clientWidth), (this.img.height = this.clientHeight)), window.MinimogEvents.emit("m:image-loaded", this.imageLoaded, this));
  }
  onLoad() {
    (this.removeAttribute(""), this.classList.add("m-image-loaded"));
  }
  observerCallback(e, t) {
    e[0].isIntersecting && (t.unobserve(this), this.loadImage());
  }
  initIntersectionObserver() {
    this.observer ||
      ((this.observer = new IntersectionObserver(this.observerCallback, {
        rootMargin: "200px 0px" ,
      })),
      this.observer.observe(this));
  }
  disconnectObserver() {
    this.observer && (this.observer.disconnect(), (this.observer = null), delete this.observer);
  }
}
customElements.define("responsive-image", ResponsiveImage);
class ProductRecommendations extends HTMLElement {
  constructor() {
    (super(),
      (this.selectors = {
        gridContainer: ".m-product-list",
        swiperWrapper: ".swiper-wrapper",
        slideControls: ".m-slider-controls",
      }),
      (this.enableSlider = "true" === this.dataset.enableSlider),
      (this.useScrollMobile = "true" === this.dataset.useScrollMobile),
      (this.itemsPerPage = this.dataset.itemsPerPage));
  }
  connectedCallback() {
    "IntersectionObserver" in window &&
      new IntersectionObserver(
        ((e, t) => {
          e[0].isIntersecting &&
            (t.unobserve(this),
            fetch(this.dataset.url)
              .then((e) => e.text())
              .then((e) => {
                let t = generateDomFromString(e).querySelector("product-recommendations");
                t &&
                  t.innerHTML.trim().length &&
                  ((this.innerHTML = t.innerHTML),
                  (this.totalProducts = t.querySelectorAll(".m-product-card").length),
                  this.initByScreenSize(),
                  document.addEventListener("matchMobile", () => {
                    this.initByScreenSize();
                  }),
                  document.addEventListener("unmatchMobile", () => {
                    this.initByScreenSize();
                  }));
              })
              .catch((e) => {}));
        }).bind(this),
        {
          rootMargin: "0px 0px 400px 0px",
        },
      ).observe(this);
  }
  initByScreenSize() {
    let { gridContainer: e, slideControls: t } = queryDomNodes(this.selectors, this);
    if (MinimogTheme.config.mqlMobile) {
      if ((this.initSlider(), !this.useScrollMobile)) return;
      (e && e.classList.remove("swiper-container"), t && t.classList.add("m:hidden"), this.swiper && this.swiper.destroy(!1, !0), e && e.parentNode.classList.add("m-mixed-layout--mobile-scroll"));
    } else (e && e.classList.add("swiper-container"), e && e.parentNode.classList.remove("m-mixed-layout--mobile-scroll"), t && t.classList.remove("m:hidden"), this.initSlider());
  }
  initSlider() {
    let e = this,
      { gridContainer: t, slideControls: i } = queryDomNodes(this.selectors, this);
    if (this.enableSlider && this.totalProducts > this.itemsPerPage) {
      if (
        ((this.slider = new MinimogLibs.Swiper(t, {
          slidesPerView: this.itemsPerPage >= 2 ? 2 : 1,
          loop: !0,
          autoplay: !1,
          pagination: {
            el: this.querySelector(".swiper-pagination"),
            clickable: !0,
            type: "fraction",
          },
          threshold: 2,
          breakpoints: {
            1280: {
              slidesPerView: this.itemsPerPage,
            },
          },
          on: {
            init: function () {
              (this.slideToLoop(this.lastActive),
                setTimeout(() => {
                  let t = e.querySelector(".m-image") || e.querySelector(".m-placeholder-svg"),
                    s = i && i.querySelector(".m-slider-controls__button-prev"),
                    n = i && i.querySelector(".m-slider-controls__button-next");
                  if (t && i) {
                    let o = t.clientHeight;
                    (i.style.setProperty("--offset-top", parseInt(o) / 2 + "px"), s.classList.remove("m:hidden"), n.classList.remove("m:hidden"));
                  }
                }, 200));
            },
          },
        })),
        this.slider)
      ) {
        i && i.classList.remove("m:hidden");
        let s = this.querySelector(".m-slider-controls__button-prev"),
          n = this.querySelector(".m-slider-controls__button-next");
        (s && s.addEventListener("click", () => this.slider.slidePrev()), n && n.addEventListener("click", () => this.slider.slideNext()));
      }
      this.swiper = t?.swiper;
    } else {
      let o = t.querySelector(".m-mixed-layout__inner");
      (o && o.classList.remove("swiper-wrapper"), i && i.classList.add("m:hidden"), t && t.classList.remove("swiper-container"));
    }
  }
}
if (
  (customElements.define("product-recommendations", ProductRecommendations),
  customElements.get("video-component") ||
    customElements.define(
      "video-component",
      class extends HTMLElement {
        constructor() {
          (super(),
            MinimogTheme.initWhenVisible({
              element: this,
              callback: this.init.bind(this),
              threshold: 0,
            }));
        }
        init() {
          ((this.autoPlay = "true" === this.dataset.autoPlay), (this.muted = "true" === this.dataset.muted));
          let e = this.querySelector('[id^="Video-Deferred-Poster-"]');
          this.autoPlay ? this.loadContent() : e && e.addEventListener("click", this.loadContent.bind(this));
        }
        loadContent() {
          if (!this.getAttribute("loaded")) {
            let e = document.createElement("div");
            (e.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)), this.setAttribute("loaded", !0));
            let t = this.appendChild(e.querySelector("video, model-viewer, iframe"));
            if (((this.deferredElement = t), !this.autoPlay)) {
              if (this.deferredElement.classList.contains("js-youtube")) {
                let i = this.deferredElement.src.indexOf("?") > -1 ? "&" : "?";
                this.deferredElement.src += i + "autoplay=1" + (this.muted ? "&mute=1" : "");
              } else if (this.deferredElement.classList.contains("js-vimeo")) {
                let s = this.deferredElement.src.indexOf("?") > -1 ? "&" : "?";
                this.deferredElement.src += s + "autoplay=1" + (this.muted ? "&mute=1" : "");
              } else this.deferredElement.play();
            }
          }
        }
      },
    ),
  !customElements.get("collapsible-tab"))
) {
  class e extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      ((this.parentEl = this.closest("[data-section-id]")), this.init());
    }
    disconnectedCallback() {
      this.destroy();
    }
    init() {
      "true" === this.dataset.destroy || (this.setDefaultData(), this.attachEvents(), "true" === this.getAttribute("open") ? ((this.selected = !0), this.classList.add(this.expandedClass), this.setExpandedAria(), this.fire("tabOpened"), window.MinimogEvents.emit("ON_COLLAPSIBLE_TAB_OPENED", this)) : ((this.content.style.height = this.collapsedHeight), this.classList.add(this.collapsedClass), this.setCollapsedAria()), this.content.removeAttribute("hidden"));
    }
    transitionendEventName() {
      let e,
        t = document.createElement("div"),
        i = {
          transition: "transitionend",
          OTransition: "otransitionend",
          MozTransition: "transitionend",
          WebkitTransition: "webkitTransitionEnd",
        };
      for (e in i) if (i.hasOwnProperty(e) && void 0 !== t.style[e]) return i[e];
    }
    expand() {
      let e = ((t) => {
        t.target === this.content &&
          (this.content.removeEventListener(this.transitionendevent, e),
          this.isOpen &&
            requestAnimationFrame(() => {
              ((this.content.style.transition = "0"),
                (this.content.style.height = "auto"),
                requestAnimationFrame(() => {
                  ((this.content.style.height = null), (this.content.style.transition = null), this.setExpandedAria(), this.classList.add(this.expandedClass), this.trySetTabIndex(this.content, 0), this.fire("tabOpened"), window.MinimogEvents.emit("ON_COLLAPSIBLE_TAB_OPENED", this));
                }));
            }));
      }).bind(this);
      (this.content.addEventListener(this.transitionendevent, e), (this.isOpen = !0), this.classList.remove(this.collapsedClass), (this.content.style.height = this.content.scrollHeight + "px"));
    }
    collapse() {
      let e = ((t) => {
        t.target === this.content && (this.content.removeEventListener(this.transitionendevent, e), this.isOpen || (this.fire("elementClosed"), window.MinimogEvents.emit("ON_COLLAPSIBLE_TAB_CLOSED", this), this.setCollapsedAria(), this.classList.add(this.collapsedClass), this.trySetTabIndex(this.content, -1)));
      }).bind(this);
      (this.content.addEventListener(this.transitionendevent, e),
        (this.isOpen = !1),
        this.classList.remove(this.expandedClass),
        requestAnimationFrame(() => {
          ((this.content.style.transition = "0"),
            (this.content.style.height = this.content.scrollHeight + "px"),
            requestAnimationFrame(() => {
              ((this.content.style.transition = null), (this.content.style.height = this.collapsedHeight));
            }));
        }));
    }
    open() {
      ((this.selected = !0), this.fire("elementSelected"), window.MinimogEvents.emit("ON_COLLAPSIBLE_TAB_SELECTED", this), this.expand(), this.setAttribute("open", !0));
    }
    close() {
      ((this.selected = !1), this.fire("elementUnselected"), window.MinimogEvents.emit("ON_COLLAPSIBLE_TAB_UNSELECTED", this), this.collapse(), this.removeAttribute("open"));
    }
    toggle(e) {
      if ((e && e.preventDefault(), this.selected)) this.close();
      else if ((this.open(), this.oneAtATime)) {
        let t = this.parentEl.querySelectorAll("collapsible-tab"),
          i = this.closest("[data-first-level]");
        t.length &&
          t.forEach((e) => {
            e !== this && e.selected && i !== e && e.close();
          });
      }
    }
    trySetTabIndex(e, t) {
      let i = e.querySelectorAll(this.defaultElements);
      i &&
        i.forEach((e) => {
          e.setAttribute("tabindex", t);
        });
    }
    setExpandedAria() {
      (this.trigger.setAttribute("aria-expanded", "true"), this.content.setAttribute("aria-hidden", "false"));
    }
    setCollapsedAria(e) {
      (this.trigger.setAttribute("aria-expanded", "false"), this.content.setAttribute("aria-hidden", "true"));
    }
    attachEvents() {
      this.trigger.addEventListener("click", (e) => this.toggle(e));
    }
    setDefaultData() {
      ((this.events = {
        elementSelected: [],
        tabOpened: [],
        elementUnselected: [],
        elementClosed: [],
      }),
        (this.transitionendevent = this.transitionendEventName()),
        (this.expandedClass = "is-expanded"),
        (this.collapsedClass = "is-collapsed"),
        (this.trigger = this.querySelector("[data-trigger]")),
        (this.content = this.querySelector("[data-content]")),
        (this.collapsedHeight = "0px"),
        (this.defaultElements = ["a", "button", "input:not(.focus-none)", "[data-trigger]"]),
        (this.oneAtATime = !0),
        this.dataset.oneOpen && (this.oneAtATime = "true" === this.dataset.oneOpen));
    }
    fire(e) {
      let t = this.events[e];
      if (t) for (let i = 0; i < t.length; i++) t[i](this);
    }
    on(e, t) {
      this.events[e] && this.events[e].push(t);
    }
    destroy() {
      (this.trigger.removeEventListener("click", (e) => this.toggle(e)), this.content.removeAttribute("aria-hidden"), (this.content.style.height = "auto"), this.classList.remove(this.expandedClass, this.collapsedClass), this.removeAttribute("open"));
    }
  }
  customElements.define("collapsible-tab", e);
}
if (
  (customElements.get("product-form") ||
    customElements.define(
      "product-form",
      class extends HTMLElement {
        constructor() {
          (super(),
            (this.selectors = {
              form: "form",
              inputId: "[name=id]",
              submitButton: '[name="add"]',
              errorWrapper: ".m-product-form-message",
              customFields: ["[data-product-custom-field]"],
              dynamicCheckout: ".m-product-dynamic-checkout",
            }));
        }
        connectedCallback() {
          ((this.domNodes = queryDomNodes(this.selectors, this)),
            (this.form = this.domNodes.form),
            (this.productInfo = this.closest(".m-main-product--info")),
            (this.submitButton = this.domNodes.submitButton),
            (this.domNodes.inputId.disabled = !1),
            (this.cart = document.querySelector("m-cart-drawer")),
            (this.cartPage = document.querySelector("m-cart")),
            (this.customFields = document.querySelectorAll(this.selectors.customFields)),
            this.domNodes.dynamicCheckout && (this.enable_dynamic_checkout = !0),
            this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
            this.domNodes.dynamicCheckout &&
              this.customFields &&
              this.domNodes.dynamicCheckout.addEventListener(
                "click",
                (e) => {
                  let t = validateForm(this.form.closest(".m-main-product--info"));
                  t &&
                    t.length > 0 &&
                    (e.stopPropagation(),
                    window.MinimogTheme.Notification.show({
                      target: this.domNodes.errorWrapper,
                      method: "appendChild",
                      type: "warning",
                      message: window.MinimogStrings.requiredField,
                      delay: 100,
                    }));
                },
                !0,
              ));
        }
        toggleSpinner(e) {
          this.classList[e ? "add" : "remove"]("m-spinner-loading");
        }
        onSubmitHandler(e) {
          (e.preventDefault(), this.toggleSpinner(!1));
          let t = validateForm(this.form.closest(".m-main-product--info"));
          if (t && t.length > 0)
            return (
              this.toggleSpinner(!1),
              window.MinimogTheme.Notification.show({
                target: this.domNodes.errorWrapper,
                method: "appendChild",
                type: "warning",
                message: window.MinimogStrings.requiredField,
              })
            );
          let i = fetchConfig("javascript");
          ((i.headers["X-Requested-With"] = "XMLHttpRequest"), delete i.headers["Content-Type"]);
          let s = new FormData(this.form);
          (this.cart &&
            (s.append(
              "sections",
              this.cart.getSectionsToRender().map((e) => e.id),
            ),
            s.append("sections_url", window.location.pathname)),
            (i.body = s));
          let { MinimogSettings: n, MinimogStrings: o } = window;
          var cartDrawer = document.querySelector("m-cart-drawer");
          if (cartDrawer) {
            document.querySelectorAll(".upsell-modal").forEach((model) => {
              model.classList.remove("active");
            });
            if (document.querySelector("m-cart-drawer-items")) {
              cartPreStruc(document.querySelector("m-cart-drawer-items"));
            }
            cartDrawer.open();
            if (document.querySelector("m-cart-drawer-items")) {
              document.querySelector("m-cart-drawer-items").loading.start();
            }
          }
          fetch(`${n.routes.cart_add_url}`, i)
            .then((e) => e.json())
            .then((e) => {
              // if (extraFreeProducts(), fetch("/cart.js", {
              //         method: "GET"
              //     }).then(function(e) {
              //         return e.json()
              //     }).then(function(e) {
              //         // document.querySelector("button[name='checkout'] [data-cart-subtotal]").innerHTML = formatMoney(e.total_price, window.custom_formate_money)
              //     }), e.status) {
              if (document.querySelector("m-cart-drawer-items")) {
                document.querySelector("m-cart-drawer-items").loading.finish();
              }
              if (document.querySelector(".upcart-product-item-skeleton")) {
                document.querySelector(".upcart-product-item-skeleton").remove();
              }
              if ((extraFreeProducts(), e.status)) {
                (window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartError, {
                  source: "product-form",
                  productVariantId: s.get("id"),
                  errors: e.description,
                  message: e.message,
                }),
                  (this.error = !0));
                let t = s.get("id");
                return "" === t || null === t
                  ? (this.handleErrorMessageVariantPicker(),
                    window.MinimogTheme.Notification.show({
                      target: this.domNodes.errorWrapper ? this.domNodes.errorWrapper : document.body,
                      method: "appendChild",
                      type: "error",
                      message: window.MinimogStrings.selectVariant,
                      last: 3e3,
                      sticky: !this.domNodes.errorWrapper,
                    }))
                  : window.MinimogTheme.Notification.show({
                      target: this.domNodes.errorWrapper ? this.domNodes.errorWrapper : document.body,
                      method: "appendChild",
                      type: "error",
                      message: e.message,
                      last: 3e3,
                      sticky: !this.domNodes.errorWrapper,
                    });
              }
              (n.use_ajax_atc
                ? this.cart && n.enable_cart_drawer
                  ? setTimeout(() => {
                      (this.cart.renderContents(e), window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer));
                    }, 100)
                  : (window.MinimogTheme.Notification.show({
                      target: this.domNodes.errorWrapper ? this.domNodes.errorWrapper : document.body,
                      method: "appendChild",
                      type: "success",
                      message: o.itemAdded,
                      last: 3e3,
                      sticky: !this.domNodes.errorWrapper,
                    }),
                    fetchJSON(window.Shopify.routes.root + "cart.json").then((e) => {
                      if (e) {
                        if (e.item_count > 0) {
                          let t = e.discount_codes || [],
                            i = t.length > 0 ? t[0].code : null;
                          toggleDiscountVisibility(i);
                        } else toggleDiscountVisibility("");
                        let s = e.item_count;
                        let cartCount = 0;

                        e.items.forEach(item => {
                          if (!item.properties || !item.properties._subProduct) {
                            cartCount += item.quantity;
                          }
                        });
                        document.querySelectorAll(".m-cart-count-bubble").forEach((e) => {
                          e.textContent = cartCount;
                        });
                      }
                    }))
                : (window.location = n.routes.cart),
                (this.error = !1),
                window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, e));
            })
            .catch((e) => {})
            .finally(() => {
              if (
                (fetchJSON(window.Shopify.routes.root + "cart.json").then((e) => {
                  if (e) {
                    if (e.item_count > 0) {
                      let t = e.discount_codes || [],
                        i = t.length > 0 ? t[0].code : null;
                      toggleDiscountVisibility(i);
                    } else toggleDiscountVisibility("");
                  }
                }),
                this.toggleSpinner(!1),
                this.cart)
              ) {
                let e = this.cart.querySelector("m-cart-drawer-items");
                (this.cart.classList.contains("m-cart--empty") && this.cart.classList.remove("m-cart--empty"), e && e.classList.contains("m-cart--empty") && e.classList.remove("m-cart--empty"));
              }
              this.cartPage && this.cartPage.classList.contains("m-cart--empty") && this.cartPage.classList.remove("m-cart--empty");
            });
        }
        handleErrorMessageVariantPicker() {
          let e = this.productInfo && this.productInfo.querySelector("variant-picker"),
            t = e && e.querySelectorAll("[data-selected-value]");
          t &&
            t.forEach((e) => {
              "" === e.dataset.selectedValue &&
                (e.classList.add("m-product-option--unselect"),
                setTimeout(() => {
                  e.classList.remove("m-product-option--unselect");
                }, 3e3));
            });
        }
      },
    ),
  !customElements.get("m-video-component"))
) {
  class t extends HTMLElement {
    constructor() {
      (super(),
        (this.background = "template" !== this.dataset.initMode),
        this.background
          ? MinimogTheme.initWhenVisible({
              element: this,
              callback: this.init.bind(this),
              threshold: 0,
            })
          : this.init());
    }
    init() {
      switch (((this.parentSelector = this.dataset.parent || ".m-hero__bg"), (this.parent = this.closest(this.parentSelector)), this.dataset.type)) {
        case "youtube":
          this.initYoutubeVideo();
          break;
        case "vimeo":
          this.initVimeoVideo();
          break;
        case "mp4":
          this.initMp4Video();
      }
    }
    initYoutubeVideo() {
      (this.setAsLoading(), this.loadScript("youtube").then(this.setupYoutubePlayer.bind(this)));
    }
    initVimeoVideo() {
      (this.setAsLoading(), this.loadScript("vimeo").then(this.setupVimeoPlayer.bind(this)));
    }
    initMp4Video() {
      let e = this.querySelector("video");
      if (e) {
        let t = e.play();
        void 0 !== t &&
          t
            .then(function () {})
            .catch(function () {
              e.setAttribute("controls", "");
            });
      }
    }
    loadScript(e) {
      return new Promise((t, i) => {
        let s = document.createElement("script");
        (document.body.appendChild(s), (s.onload = t), (s.onerror = i), (s.async = !0), (s.src = "youtube" === e ? "//www.youtube.com/iframe_api" : "//player.vimeo.com/api/player.js"));
      });
    }
    setAsLoading() {
      this.parent.setAttribute("loading", !0);
    }
    setAsLoaded() {
      (this.parent.removeAttribute("loading"), this.parent.setAttribute("loaded", !0));
    }
    setupYoutubePlayer() {
      let e = this.dataset.videoId,
        t = setInterval(() => {
          window.YT &&
            window.YT.ready(() => {
              let i = document.createElement("div");
              (this.appendChild(i),
                (this.player = new YT.Player(i, {
                  videoId: e,
                  playerVars: {
                    showinfo: 0,
                    controls: !1,
                    fs: 0,
                    rel: 0,
                    height: "100%",
                    width: "100%",
                    iv_load_policy: 3,
                    html5: 1,
                    loop: 1,
                    playsinline: 1,
                    modestbranding: 1,
                    disablekb: 1,
                  },
                  events: {
                    onReady: this.onYoutubeReady.bind(this),
                    onStateChange: this.onYoutubeStateChange.bind(this),
                  },
                })),
                clearInterval(t));
            });
        }, 50);
    }
    onYoutubeReady() {
      ((this.iframe = this.querySelector("iframe")),
        this.iframe.setAttribute("tabindex", "-1"),
        "function" == typeof this.player.mute && this.player.mute(),
        "function" == typeof this.player.playVideo && this.player.playVideo(),
        this.setAsLoaded(),
        "IntersectionObserver" in window &&
          new IntersectionObserver(
            (e, t) => {
              e.forEach((e) => {
                e.isIntersecting ? this.youtubePlay() : this.youtubePause();
              });
            },
            {
              rootMargin: "0px 0px 50px 0px",
            },
          ).observe(this.iframe));
    }
    onYoutubeStateChange(e) {
      switch (e.data) {
        case -1:
          this.attemptedToPlay && this.setAsLoaded();
          break;
        case 0:
          this.youtubePlay();
          break;
        case 1:
          this.setAsLoaded();
          break;
        case 3:
          this.attemptedToPlay = !0;
      }
    }
    youtubePlay() {
      this.player && "function" == typeof this.player.playVideo && this.player.playVideo();
    }
    youtubePause() {
      this.player && "function" == typeof this.player.pauseVideo && this.player.pauseVideo();
    }
    setupVimeoPlayer() {
      let e = this.dataset.videoId,
        t = setInterval(() => {
          window.Vimeo &&
            ((this.player = new Vimeo.Player(this, {
              id: e,
              autoplay: !0,
              autopause: !1,
              background: !1,
              controls: !1,
              loop: !0,
              height: "100%",
              width: "100%",
            })),
            this.player.ready().then(this.onVimeoReady.bind(this)),
            clearInterval(t));
        }, 50);
    }
    onVimeoReady() {
      ((this.iframe = this.querySelector("iframe")),
        this.iframe.setAttribute("tabindex", "-1"),
        this.player.setMuted(!0),
        this.setAsLoaded(),
        new IntersectionObserver(
          (e, t) => {
            e.forEach((e) => {
              e.isIntersecting ? this.vimeoPlay() : this.vimeoPause();
            });
          },
          {
            rootMargin: "0px 0px 50px 0px",
          },
        ).observe(this.iframe));
    }
    vimeoPlay() {
      this.player && "function" == typeof this.player.play && this.player.play();
    }
    vimeoPause() {
      this.player && "function" == typeof this.player.pause && this.player.pause();
    }
  }
  customElements.define("m-video-component", t);
}
if (!customElements.get("m-search-popup")) {
  class i extends HTMLElement {
    constructor() {
      (super(),
        (this.selectors = {
          container: "[data-search-container]",
          form: "form",
          input: "[data-search-input]",
          submit: 'button[type="submit"]',
          loading: "[data-spinner]",
          close: "[data-close-search]",
        }));
      let e = document.querySelector("[data-search-popup]");
      if (!e) return;
      ((this.domNodes = queryDomNodes(this.selectors, e)),
        (this.domNodes.searchPopup = e),
        document.body.appendChild(e),
        addEventDelegate({
          selector: "[data-open-search-popup]",
          handler: () => this.openSearchPopup(),
        }));
      let { input: t, submit: i, close: s, form: n } = this.domNodes;
      (t &&
        t.addEventListener("keydown", (e) => {
          27 === e.keyCode && this.closeSearchPopup();
        }),
        i.addEventListener("click", (e) => {
          (e.preventDefault(), t.value && n.submit());
        }),
        s.addEventListener("click", (e) => {
          (this.closeSearchPopup(), MinimogEvents.emit(MinimogTheme.pubSubEvents.closeSearchPopup));
        }),
        e.addEventListener("click", (t) => {
          t.target === e && this.closeSearchPopup();
        }),
        MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openCartDrawer, () => {
          this.hasAttribute("open") && this.closeSearchPopup();
        }));
    }
    openSearchPopup() {
      let { searchPopup: e, input: t, container: i } = this.domNodes;
      (e.style.removeProperty("visibility"),
        e.style.setProperty("opacity", "1"),
        i.classList.add("m-show-search"),
        this.setAttribute("open", !0),
        setTimeout(() => {
          (i.style.removeProperty("--m-durations"), t.focus());
        }, 350),
        document.documentElement.classList.add("prevent-scroll"),
        MinimogEvents.emit(MinimogTheme.pubSubEvents.openSearchPopup, this));
    }
    closeSearchPopup() {
      let { searchPopup: e, container: t } = this.domNodes;
      (t.classList.remove("m-show-search"),
        e.style.setProperty("opacity", "0"),
        setTimeout(() => {
          (e.style.setProperty("visibility", "hidden"), t.style.setProperty("--m-durations", ".3s"), document.documentElement.classList.remove("prevent-scroll"), this.removeAttribute("open"));
        }, 350));
    }
  }
  customElements.define("m-search-popup", i);
}
if (!customElements.get("m-select-component")) {
  class s extends HTMLElement {
    constructor() {
      (super(),
        (this.selectors = {
          elSelectNative: ".js-selectNative",
          elSelectCustom: ".js-selectCustom",
          elSelectCustomBox: ".m-select-custom--trigger",
          elSelectCustomOpts: ".m-select-custom--options",
          elSelectCustomTriggerText: ".m-select-custom--trigger-text",
          customOptionList: [".m-select-custom--option"],
        }),
        (this.domNodes = queryDomNodes(this.selectors, this)),
        (this.optionChecked = ""),
        window.addEventListener("DOMContentLoaded", () => {
          this.classList.remove("m:hidden");
        }),
        this.setDefaultValue(),
        this.initSelect());
    }
    setDefaultValue() {
      let { elSelectNative: e } = this.domNodes,
        t = e.options[e.selectedIndex].value,
        i = e.options[e.selectedIndex].text;
      this.updateCustomSelectChecked(t, i);
    }
    initSelect() {
      this.classList.remove("m:hidden");
      let { elSelectNative: e, elSelectCustom: t, elSelectCustomBox: i } = this.domNodes;
      (i.addEventListener("click", () => {
        t.classList.contains("isActive") ? this.closeSelect() : this.openSelect();
      }),
        this.domNodes.customOptionList.forEach((t) => {
          t.addEventListener("click", (t) => {
            let i = t.target.getAttribute("data-value");
            ((e.value = i), this.closeSelect(), this.updateCustomSelectChecked(i, t.target.textContent), e.dispatchEvent(new Event("change")), e.dispatchEvent(new Event("click")));
          });
        }));
    }
    openSelect() {
      let e = document.querySelectorAll("m-select-component");
      (document.addEventListener("click", (e) => this.handleClickOutside(e)),
        e.length > 0 &&
          e.forEach((e) => {
            e.closeSelect();
          }),
        this.domNodes.elSelectCustom.classList.add("isActive"));
    }
    closeSelect() {
      this.domNodes.elSelectCustom.classList.remove("isActive");
    }
    updateCustomSelectChecked(e, t) {
      let { elSelectCustomOpts: i, elSelectCustomTriggerText: s } = this.domNodes,
        n = this.optionChecked,
        o = i.querySelector(`[data-value="${n}"`),
        r = i.querySelector(`[data-value="${e}"`);
      (o && o.classList.remove("isActive"), r && r.classList.add("isActive"), (s.textContent = t), (this.optionChecked = e));
    }
    handleClickOutside(e) {
      let { elSelectCustom: t } = this.domNodes;
      t.contains(e.target) || this.closeSelect();
    }
  }
  customElements.define("m-select-component", s);
}
if (!customElements.get("m-instagram")) {
  class n extends HTMLElement {
    constructor() {
      (super(), this.init());
    }
    init() {
      let { MinimogThemeScripts: e } = window,
        { accessToken: t, imagesCount: i } = this.dataset;
      t &&
        loadAssetsNew([e.instagram], "instagram-module", () => {
          new MinimogTheme.Instagram(this, t, i);
        });
    }
  }
  customElements.define("m-instagram", n);
}
if (!customElements.get("m-aside-instagram")) {
  class o extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      let e = this.querySelector(".m-aside-instagram");
      if (e) {
        let { accessToken: t, imagesCount: i } = e.dataset;
        if (t) {
          let { MinimogThemeScripts: s } = window;
          loadAssetsNew([s.instagram], "instagram-module-blog", () => {
            new MinimogTheme.Instagram(e, t, i);
          });
        }
      }
    }
  }
  customElements.define("m-aside-instagram", o);
}
class MQuantityInput extends HTMLElement {
  constructor() {
    (super(), this.init());
  }
  init() {
    ((this.input = this.querySelector("input")),
      (this.changeEvent = new Event("change", {
        bubbles: !0,
      })),
      this.input.addEventListener("change", this.onInputChange.bind(this)),
      this.querySelectorAll("button").forEach((e) => e.addEventListener("click", this.onButtonClick.bind(this))),
      (this.quantityUpdateUnsubscriber = void 0));
  }
  onInputChange(e) {
    this.validateQtyRules();
  }
  onButtonClick(e) {
    e.preventDefault();
    let t = this.input.value;
    ("plus" === e.target.closest("button").name ? this.input.stepUp() : this.input.stepDown(), t !== this.input.value && this.input.dispatchEvent(this.changeEvent));
  }
  validateQtyRules() {
    let e = parseInt(this.input.value);
    if (this.input.min) {
      let t = parseInt(this.input.min);
      this.querySelector(".m-quantity__button[name='minus']").classList.toggle("m:disabled", e <= t);
    }
    if (this.input.max) {
      let i = parseInt(this.input.max);
      this.querySelector(".m-quantity__button[name='plus']").classList.toggle("m:disabled", e >= i);
    }
  }
}
customElements.define("m-quantity-input", MQuantityInput);
class ProductRecentlyViewed extends HTMLElement {
  constructor() {
    if ((super(), isStorageSupported("local"))) {
      let e = parseInt(this.dataset.productId),
        t = "minimog-recently-viewed",
        i = JSON.parse(window.localStorage.getItem(t) || "[]");
      (i.includes(e) || i.unshift(e), window.localStorage.setItem(t, JSON.stringify(i.slice(0, 20))));
    }
  }
}
customElements.define("product-recently-viewed", ProductRecentlyViewed);
// video-slider

// Swiper: Slider
// new Swiper(".swiper-container", {
//   loop: true,
//   nextButton: ".swiper-button-next",
//   prevButton: ".swiper-button-prev",
//   slidesPerView: 1,
//   paginationClickable: true,
//   spaceBetween: 20,
//   breakpoints: {
//     1920: {
//       slidesPerView: 3,
//       spaceBetween: 30,
//     },
//     1028: {
//       slidesPerView: 2,
//       spaceBetween: 30,
//     },
//     480: {
//       slidesPerView: 1,
//       spaceBetween: 10,
//     },
//   },
// });

// custom_review_ js

var swiper = new Swiper(".section_custom_review_main .swiper-container", {
  loop: true,
  navigation: {
    nextEl: ".swiper-aerrows_and_paginations .swiper-button-next",
    prevEl: ".swiper-aerrows_and_paginations .swiper-button-prev",
  },
  slidesPerView: 1,
  pagination: {
    el: ".swiper-aerrows_and_paginations .swiper-pagination",
    clickable: true,
    draggable: true,
  },
  centeredSlides: false,
  spaceBetween: 20,
  breakpoints: {
    1024: {
      slidesPerView: 3,
      spaceBetween: 44,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
  },
});

if (document.querySelector(".section_product_custom_review_main .swiper-container")) {
  var swiper = new Swiper(".section_product_custom_review_main .swiper-container", {
    loop: true,
    slidesPerView: 1.2,
    // navigation: {
    //   nextEl: ".swiper-aerrows_and_paginations .swiper-button-next",
    //   prevEl: ".swiper-aerrows_and_paginations .swiper-button-prev",
    // },
    pagination: {
      el: ".swiper-aerrows_and_paginations .swiper-pagination",
      clickable: true,
      draggable: true,
    },
    centeredSlides: true,
    spaceBetween: 16,
    breakpoints: {
      1281: {
        slidesPerView: 5,
      },
      1024: {
        slidesPerView: 3,
      },
      769: {
        slidesPerView: 2.2,
      },
    },
  });
}

// custom transformation mobile slider
var swiper_transformation = new Swiper(".custom-transformation .swiper-container", {
  navigation: {
    nextEl: ".swiper-aerrows_and_paginations .swiper-button-next",
    prevEl: ".swiper-aerrows_and_paginations .swiper-button-prev",
  },
  slidesPerView: 1,
  pagination: {
    el: ".swiper-aerrows_and_paginations .swiper-pagination",
    clickable: true,
    draggable: true,
  },
  centeredSlides: false,
});

// review slider 3
var swiper_2 = new Swiper(".review-slider-3 .swiper-container", {
  loop: true,
  navigation: {
    nextEl: ".swiper-aerrows_and_paginations .swiper-button-next",
    prevEl: ".swiper-aerrows_and_paginations .swiper-button-prev",
  },
  slidesPerView: 1,
  pagination: {
    el: ".swiper-aerrows_and_paginations .swiper-pagination",
    clickable: true,
    draggable: true,
  },
  centeredSlides: false,
  spaceBetween: 20,
  breakpoints: {
    1024: {
      slidesPerView: 3.5,
      spaceBetween: 35,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
  },
});
var swiper_3 = new Swiper(".product-customer-review .swiper-container", {
  centeredSlides: false,
  spaceBetween: 20,
  slidesPerView: 1,
  breakpoints: {
    1024: {
      slidesPerView: 3,
      spaceBetween: 24,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
  },
});

// option-detail section
var swiper_4 = new Swiper(".option_detail_slider .swiper-container", {
  loop: true,
  navigation: {
    nextEl: ".swiper-aerrows_and_paginations .swiper-button-next",
    prevEl: ".swiper-aerrows_and_paginations .swiper-button-prev",
  },
  slidesPerView: 1,
  pagination: {
    el: ".swiper-aerrows_and_paginations .swiper-pagination",
    clickable: true,
    draggable: true,
  },
  centeredSlides: false,
  breakpoints: {
    1024: {
      slidesPerView: 3,
    },
    768: {
      slidesPerView: 2,
    },
  },
});

var review_slider_swiper = new Swiper(".review_slider_2 .swiper-container", {
  loop: true,
  navigation: {
    nextEl: ".swiper-aerrows_and_paginations .swiper-button-next",
    prevEl: ".swiper-aerrows_and_paginations .swiper-button-prev",
  },
  spaceBetween: 30,

  breakpoints: {
    1200: {
      slidesPerView: 4.5,
      pagination: false,
    },
    1024: {
      slidesPerView: 4.5,
    },
    769: {
      pagination: false,
      slidesPerView: 3.5,
    },
    768: {
      slidesPerView: 1.5,
      spaceBetween: 25,
    },
    320: {
      slidesPerView: 1.5,
      spaceBetween: 25,
      pagination: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    },
  },
});

var reviewSwiper = new Swiper(".home_review_section .swiper", {
  slidesToScroll: 1,
  slidesPerView: 1.5,
  navigation: {
    nextEl: ".swiper-button-next-custom",
    prevEl: ".swiper-button-prev-custom",
  },
  breakpoints: {
    1200: {
      slidesPerView: 4.5,
    },
    991: {
      slidesPerView: 3.5,
    },
    768: {
      slidesPerView: 2.5,
    },
    540: {
      slidesPerView: 1.5,
    },
  },
});

function getSavePercent(oldPrice, newPrice) {
  if (!oldPrice || !newPrice) return 0;

  const savePercent = ((oldPrice - newPrice) / oldPrice) * 100;
  return Math.round(savePercent);
}

$(document).on("click", ".question-icon", function () {
  console.log("inn");
  $(this).parents(".option-label").siblings(".question-tooltip-content").removeClass("hidden");
});

$(document).on("click", ".close-btn", function () {
  $(this).parents(".question-tooltip-content").addClass("hidden");
});

// Review slider tab view
function openTab(event, tabName) {
  const tabs = document.querySelectorAll(".tab");
  tabs.forEach((tab) => {
    tab.classList.remove("active");
  });
  const buttons = document.querySelectorAll(".tab-button");
  buttons.forEach((button) => {
    button.classList.remove("active");
  });
  if (document.getElementById(tabName) != null) {
    document.getElementById(tabName).classList.add("active");
  }
  if (event.currentTarget != null) {
    event.currentTarget.classList.add("active");
  }
}

// Active tab initialization
openTab({ currentTarget: document.querySelector(".tab-button.active") }, "Tab1");

document.querySelectorAll(".m-featured-product").forEach(function (element) {
  const elementToMove = element.querySelector(".main-product__block.main-product__block-variant_picker");
  const targetElement = element.querySelector(".m-product-form--wrapper");

  // Ensure both elements exist before attempting to move
  if (elementToMove && targetElement && targetElement.parentNode) {
    targetElement.parentNode.insertBefore(elementToMove, targetElement);
  }
});

// loop subscription app Code =====================================================================================================================

let checkIntervalLoop = setInterval(() => {
  let elements = document.querySelectorAll(".loop-w-btn-group-purchase-options-container");
  if (elements.length > 0) {
    document.querySelectorAll(".loop-w-btn-group-purchase-options-container .loop-w-btn-group-purchase-option").forEach(function (ele) {
      // if (ele.getAttribute("data-selling-plan-group") != null) {
      //   ele.querySelector(".sls-selling-plan-group-name").innerText = 'Abonnieren & Sparen';
      // }

      ele.addEventListener("click", function () {
        var eleSalePrice = 0;
        var priceElement = this.closest(".shopify-section").querySelectorAll(".m-add-to-cart--price,.m-price-item--sale");
        var priceElementGetPrice = this.closest(".shopify-section").querySelector(".m-add-to-cart--price").getAttribute("data-price");
        var priceElementGetComparePrice = this.closest(".shopify-section").querySelector(".m-add-to-cart-compare-price").getAttribute("data-price");
        if (this.classList.contains("loop-w-btn-group-purchase-option-onetime")) {
          var eleSalePrice = priceElementGetPrice;
          this.closest(".shopify-section").classList.remove("subscription_select");
          this.closest(".shopify-section")
            .querySelectorAll(".variant-price .subsription-price")
            .forEach((el) => (el.style.display = "none"));
          this.closest(".shopify-section")
            .querySelectorAll(".variant-price .main-price")
            .forEach((el) => (el.style.display = "block"));
          this.closest(".shopify-section")
            .querySelectorAll(".variant-price-per-day .per-day-subsription")
            .forEach((el) => (el.style.display = "none"));
          this.closest(".shopify-section")
            .querySelectorAll(".variant-price-per-day .per-day-onetime")
            .forEach((el) => (el.style.display = "block"));
          this.closest(".shopify-section")
            .querySelectorAll(".variant-bottom-text")
            .forEach((el) => (el.style.display = "none"));

          var discounted_custom_price = Number(document.querySelector(".m-product-option--node.active").getAttribute("data-price"));
          var discounted_custom_compare_price = Number(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"));
          document.querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart--price,.custom-product-price .price-item--sale").forEach((element) => {
            element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-price"), window.MinimogSettings.money_format);
          });

          if (discounted_custom_price == discounted_custom_compare_price) {
            document.querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart-compare-price,.custom-product-price .m-price-item--regular").forEach((element) => {
              element.style.display = "none";
              element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"), window.MinimogSettings.money_format);
            });
          } else {
            document.querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart-compare-price,.custom-product-price .m-price-item--regular").forEach((element) => {
              element.style.display = "block";
              element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"), window.MinimogSettings.money_format);
            });
          }
        } else {
          var priceElementQuantity = 1;
          if (this.closest(".shopify-section").querySelector(".m-product-option--node.active .top-title")) {
            var priceElementQuantity = this.closest(".shopify-section").querySelector(".m-product-option--node.active .top-title").getAttribute("data-variant-title").split("")[0];
          }
          console.log(priceElementQuantity);
          var minusPrice = 500 * Number(priceElementQuantity);

          var eleSalePrice = Number(priceElementGetPrice) - minusPrice;
          this.closest(".shopify-section").classList.add("subscription_select");
          this.closest(".shopify-section")
            .querySelectorAll(".variant-price .subsription-price")
            .forEach((el) => (el.style.display = "block"));
          this.closest(".shopify-section")
            .querySelectorAll(".variant-price .main-price")
            .forEach((el) => (el.style.display = "none"));
          this.closest(".shopify-section")
            .querySelectorAll(".variant-price-per-day .per-day-subsription")
            .forEach((el) => (el.style.display = "block"));
          this.closest(".shopify-section")
            .querySelectorAll(".variant-price-per-day .per-day-onetime")
            .forEach((el) => (el.style.display = "none"));
          this.closest(".shopify-section")
            .querySelectorAll(".variant-bottom-text")
            .forEach((el) => (el.style.display = "block"));
          var selected_value = this.closest(".shopify-section").querySelector(".loop-w-btn-group-purchase-options-container .loop-w-btn-group-purchase-option.loop-w-btn-group-purchase-option-selected");
          var priceElementGetPrice = this.closest(".shopify-section").querySelector(".m-add-to-cart--price") ? this.closest(".shopify-section").querySelector(".m-add-to-cart--price").getAttribute("data-price") : 0;

          var discounted_custom_price = Number(document.querySelector(".m-product-option--node.active").getAttribute("data-subscription-price"));
          var discounted_custom_compare_price = Number(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"));
          document.querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart--price,.custom-product-price .price-item--sale").forEach((element) => {
            element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-subscription-price"), window.MinimogSettings.money_format);
          });

          if (discounted_custom_price == discounted_custom_compare_price) {
            document.querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart-compare-price,.custom-product-price .m-price-item--regular").forEach((element) => {
              element.style.display = "none";
              element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"), window.MinimogSettings.money_format);
            });
          } else {
            document.querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart-compare-price,.custom-product-price .m-price-item--regular").forEach((element) => {
              element.style.display = "block";
              element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"), window.MinimogSettings.money_format);
            });
          }
        }

        document.querySelectorAll(".m-add-to-cart--price-wrapper.non-sub-price .m-add-to-cart--price").forEach((element) => {
          element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-price"), window.custom_formate_money_no_decimals);
        });

        if (document.querySelector(".custom-price__badge-sale .m-product-tag")) {
          let original_custom_price = Number(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"));
          const custom_discount = (((original_custom_price - discounted_custom_price) / original_custom_price) * 100).toFixed(0);
          document.querySelector(".custom-price__badge-sale .m-product-tag").innerHTML = `Sparen Sie ${custom_discount}%`;
        }

        const getPR = getSavePercent(priceElementGetComparePrice, eleSalePrice);
        if (this.closest(".shopify-section").querySelector("[data-saved-price]")) {
          this.closest(".shopify-section").querySelector("[data-saved-price]").innerHTML = `${getPR}%`;
        }
      });
    });

    const element = document.querySelector(".loop-w-btn-group-purchase-option:not(.loop-w-btn-group-purchase-option-onetime)");
    if (element) {
      const clickEvent = new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window,
      });

      element.dispatchEvent(clickEvent);
    }

    document.querySelectorAll(".m-main-product--wrapper").forEach(function (ele) {
      var selected_value = ele.querySelector(".loop-w-btn-group-purchase-options-container .loop-w-btn-group-purchase-option.loop-w-btn-group-purchase-option-selected");
      if (selected_value) {
        var eleSalePrice = 0;
        var priceElementGetComparePrice = selected_value.closest(".shopify-section").querySelector(".m-add-to-cart-compare-price").getAttribute("data-price");
        var priceElement = selected_value.closest(".shopify-section").querySelectorAll(".m-add-to-cart--price,.m-price-item--sale");
        var priceElementGetPrice = selected_value.closest(".shopify-section").querySelector(".m-add-to-cart--price") ? selected_value.closest(".shopify-section").querySelector(".m-add-to-cart--price").getAttribute("data-price") : "";

        if (selected_value) {
          if (selected_value.classList.contains("loop-w-btn-group-purchase-option-onetime")) {
            var eleSalePrice = priceElementGetPrice;
            selected_value.closest(".shopify-section").classList.remove("subscription_select");
            selected_value
              .closest(".shopify-section")
              .querySelectorAll(".variant-price .subsription-price")
              .forEach((el) => (el.style.display = "none"));
            selected_value
              .closest(".shopify-section")
              .querySelectorAll(".variant-price .main-price")
              .forEach((el) => (el.style.display = "block"));
            selected_value
              .closest(".shopify-section")
              .querySelectorAll(".variant-price-per-day .per-day-subsription")
              .forEach((el) => (el.style.display = "none"));
            selected_value
              .closest(".shopify-section")
              .querySelectorAll(".variant-price-per-day .per-day-onetime")
              .forEach((el) => (el.style.display = "block"));
            selected_value
              .closest(".shopify-section")
              .querySelectorAll(".variant-bottom-text")
              .forEach((el) => (el.style.display = "none"));
            var discounted_custom_price = Number(document.querySelector(".m-product-option--node.active").getAttribute("data-price"));
            var discounted_custom_compare_price = Number(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"));
            document.querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart--price,.custom-product-price .price-item--sale").forEach((element) => {
              element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-price"), window.MinimogSettings.money_format);
            });
            if (discounted_custom_price == discounted_custom_compare_price) {
              document.querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart-compare-price,.custom-product-price .m-price-item--regular").forEach((element) => {
                element.style.display = "none";
                element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"), window.MinimogSettings.money_format);
              });
            } else {
              document.querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart-compare-price,.custom-product-price .m-price-item--regular").forEach((element) => {
                element.style.display = "block";
                element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"), window.MinimogSettings.money_format);
              });
            }
          } else {
            var priceElementQuantity = 1;
            if (selected_value.closest(".shopify-section").querySelector(".m-product-option--node.active .top-title")) {
              var priceElementQuantity = selected_value.closest(".shopify-section").querySelector(".m-product-option--node.active .top-title").getAttribute("data-variant-title").split("")[0];
            }
            var minusPrice = 500 * Number(priceElementQuantity);

            var eleSalePrice = Number(priceElementGetPrice) - minusPrice;
            selected_value.closest(".shopify-section").classList.add("subscription_select");
            selected_value
              .closest(".shopify-section")
              .querySelectorAll(".variant-price .subsription-price")
              .forEach((el) => (el.style.display = "block"));
            selected_value
              .closest(".shopify-section")
              .querySelectorAll(".variant-price .main-price")
              .forEach((el) => (el.style.display = "none"));
            selected_value
              .closest(".shopify-section")
              .querySelectorAll(".variant-price-per-day .per-day-subsription")
              .forEach((el) => (el.style.display = "block"));
            selected_value
              .closest(".shopify-section")
              .querySelectorAll(".variant-price-per-day .per-day-onetime")
              .forEach((el) => (el.style.display = "none"));
            selected_value
              .closest(".shopify-section")
              .querySelectorAll(".variant-bottom-text")
              .forEach((el) => (el.style.display = "block"));

            var discounted_custom_price = Number(document.querySelector(".m-product-option--node.active").getAttribute("data-subscription-price"));
            var discounted_custom_compare_price = Number(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"));
            document.querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart--price,.custom-product-price .price-item--sale").forEach((element) => {
              element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-subscription-price"), window.MinimogSettings.money_format);
            });

            if (discounted_custom_price == discounted_custom_compare_price) {
              document.querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart-compare-price,.custom-product-price .m-price-item--regular").forEach((element) => {
                element.style.display = "none";
                element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"), window.MinimogSettings.money_format);
              });
            } else {
              document.querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart-compare-price,.custom-product-price .m-price-item--regular").forEach((element) => {
                element.style.display = "block";
                element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"), window.MinimogSettings.money_format);
              });
            }
          }
        }

        const getPR = getSavePercent(priceElementGetComparePrice, eleSalePrice);
        if (selected_value.closest(".shopify-section").querySelector("[data-saved-price]")) {
          selected_value.closest(".shopify-section").querySelector("[data-saved-price]").innerHTML = `${getPR}%`;
        }
        // document.querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart-compare-price,.custom-product-price .m-price-item--regular").forEach(element => {
        //   element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"),window.MinimogSettings.money_format);
        // });

        if (document.querySelector(".custom-price__badge-sale .m-product-tag")) {
          let original_custom_price = Number(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"));
          const custom_discount = (((original_custom_price - discounted_custom_price) / original_custom_price) * 100).toFixed(0);
          document.querySelector(".custom-price__badge-sale .m-product-tag").innerHTML = `Sparen Sie ${custom_discount}%`;
        }
        document.querySelectorAll(".m-add-to-cart--price-wrapper.non-sub-price .m-add-to-cart--price").forEach((element) => {
          element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-price"), window.custom_formate_money_no_decimals);
        });
      }
    });
    clearInterval(checkIntervalLoop);
  }
}, 500);

// Product page review slider
var product_review_slider = new Swiper(".product-review-slider-main", {
  slidesPerView: 1,
  spaceBetween: 20,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    766: {
      spaceBetween: 30,
    },
  },
});

// Product page Subscription Change name

const interval = setInterval(() => {
  const groupNameEl = document.querySelector(".sls-selling-plan-group-name");

  if (groupNameEl) {
    const text = groupNameEl.innerText;
    if (text.includes("Einmaliger Kauf")) {
      groupNameEl.innerText = "One-time delivery";
    }
    clearInterval(interval); // Stop checking once done
  }
}, 100); // check every 200ms

// Optional: stop trying after 10 seconds to avoid infinite loop
setTimeout(() => clearInterval(interval), 10000);

// Product page Subscription add text

const intervalInSlsOption = setInterval(() => {
  const elements = document.querySelectorAll(".sls-option-container:not([data-enhanced]),.loop-w-btn-group-purchase-option:not(.loop-w-btn-group-purchase-option-onetime)");
  if (elements.length > 0) {
    elements.forEach((additionalText) => {
      if (!additionalText.querySelector(".bottom-title")) {
        const bottomTitle = document.createElement("span");
        bottomTitle.className = "bottom-title";
        bottomTitle.textContent = "Flexible. Cancel anytime.";
        additionalText.appendChild(bottomTitle);
        additionalText.setAttribute("data-enhanced", "true");
      }
    });
    // clearInterval(intervalInSlsOption); // Stop checking after it's done
  }
}, 200); // Check every 200ms

if (window.location.href.includes("/products")) {
  document.addEventListener("click", function (e) {
    const target = e.target.closest(".loop-w-btn-group-purchase-option");

    if (target) {
      const container = target.closest(".m-main-product--info");
      var eleSalePrice = 0;
      var priceElementGetComparePrice = target.closest(".shopify-section").querySelector(".m-add-to-cart-compare-price").getAttribute("data-price");
      var priceElement = target.closest(".shopify-section").querySelectorAll(".m-add-to-cart--price,.m-price-item--sale");
      var priceElementGetPrice = target.closest(".shopify-section").querySelector(".m-add-to-cart--price") ? target.closest(".shopify-section").querySelector(".m-add-to-cart--price").getAttribute("data-price") : 0;
      if (target.classList.contains("loop-w-btn-group-purchase-option-onetime")) {
        console.log("hello there");
        container.classList.remove("subscription-select");
        container.classList.add("onetime-select");

        var eleSalePrice = priceElementGetPrice;
        target
          .closest(".shopify-section")
          .querySelectorAll(".variant-price .subsription-price")
          .forEach((el) => (el.style.display = "none"));
        target
          .closest(".shopify-section")
          .querySelectorAll(".variant-price .main-price")
          .forEach((el) => (el.style.display = "block"));
        target
          .closest(".shopify-section")
          .querySelectorAll(".variant-price-per-day .per-day-subsription")
          .forEach((el) => (el.style.display = "none"));
        target
          .closest(".shopify-section")
          .querySelectorAll(".variant-price-per-day .per-day-onetime")
          .forEach((el) => (el.style.display = "block"));
        target
          .closest(".shopify-section")
          .querySelectorAll(".variant-bottom-text")
          .forEach((el) => (el.style.display = "none"));
        var discounted_custom_price = Number(document.querySelector(".m-product-option--node.active").getAttribute("data-price"));
        var discounted_custom_compare_price = Number(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"));
        document.querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart--price,.custom-product-price .price-item--sale").forEach((element) => {
          element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-price"), window.MinimogSettings.money_format);
        });
        if (discounted_custom_price == discounted_custom_compare_price) {
          document.querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart-compare-price,.custom-product-price .m-price-item--regular").forEach((element) => {
            element.style.display = "none";
            element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"), window.MinimogSettings.money_format);
          });
        } else {
          document.querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart-compare-price,.custom-product-price .m-price-item--regular").forEach((element) => {
            element.style.display = "block";
            element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"), window.MinimogSettings.money_format);
          });
        }
      } else {
        var discounted_custom_price = Number(document.querySelector(".m-product-option--node.active").getAttribute("data-subscription-price"));
        var discounted_custom_compare_price = Number(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"));
        document.querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart--price,.custom-product-price .price-item--sale").forEach((element) => {
          element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-subscription-price"), window.MinimogSettings.money_format);
        });
        if (discounted_custom_price == discounted_custom_compare_price) {
          document.querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart-compare-price,.custom-product-price .m-price-item--regular").forEach((element) => {
            element.style.display = "none";
            element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"), window.MinimogSettings.money_format);
          });
        } else {
          document.querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart-compare-price,.custom-product-price .m-price-item--regular").forEach((element) => {
            element.style.display = "block";
            element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"), window.MinimogSettings.money_format);
          });
        }

        container.classList.add("subscription-select");
        container.classList.remove("onetime-select");
        var priceElementQuantity = 1;
        if (target.closest(".shopify-section").querySelector(".m-product-option--node.active .top-title")) {
          var priceElementQuantity = target.closest(".shopify-section").querySelector(".m-product-option--node.active .top-title").getAttribute("data-variant-title").split("")[0];
        }
        var minusPrice = 500 * Number(priceElementQuantity);

        var eleSalePrice = Number(priceElementGetPrice) - minusPrice;
        target.closest(".shopify-section").classList.add("subscription_select");
        target
          .closest(".shopify-section")
          .querySelectorAll(".variant-price .subsription-price")
          .forEach((el) => (el.style.display = "block"));
        target
          .closest(".shopify-section")
          .querySelectorAll(".variant-price .main-price")
          .forEach((el) => (el.style.display = "none"));
        target
          .closest(".shopify-section")
          .querySelectorAll(".variant-price-per-day .per-day-subsription")
          .forEach((el) => (el.style.display = "block"));
        target
          .closest(".shopify-section")
          .querySelectorAll(".variant-price-per-day .per-day-onetime")
          .forEach((el) => (el.style.display = "none"));
        target
          .closest(".shopify-section")
          .querySelectorAll(".variant-bottom-text")
          .forEach((el) => (el.style.display = "block"));
      }

      // document.querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart-compare-price,.custom-product-price .m-price-item--regular").forEach(element => {
      //   element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"),window.MinimogSettings.money_format);
      // });

      document.querySelectorAll(".m-add-to-cart--price-wrapper.non-sub-price .m-add-to-cart--price").forEach((element) => {
        element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-price"), window.custom_formate_money_no_decimals);
      });
      if (document.querySelector(".custom-price__badge-sale .m-product-tag")) {
        let original_custom_price = Number(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"));
        const custom_discount = (((original_custom_price - discounted_custom_price) / original_custom_price) * 100).toFixed(0);
        document.querySelector(".custom-price__badge-sale .m-product-tag").innerHTML = `Sparen Sie ${custom_discount}%`;
      }
      const getPR = getSavePercent(priceElementGetComparePrice, eleSalePrice);
      if (target.closest(".shopify-section").querySelector("[data-saved-price]")) {
        target.closest(".shopify-section").querySelector("[data-saved-price]").innerHTML = `${getPR}%`;
      }
    }
  });
} else {
  document.querySelectorAll(".product-feature-page .m-product-option--node input").forEach((element) => {
    element.addEventListener("change", function (e) {
      const target = e.target;

      if (target) {
        var getSubscriptionId = target.getAttribute("data-subscription-id");
        if (getSubscriptionId) {
          document.querySelectorAll("input[name='selling_plan']").forEach((input) => {
            input.value = getSubscriptionId;
          });
          const container = target.closest(".m-main-product--info");
          var priceElement = target.closest(".shopify-section").querySelectorAll(".m-add-to-cart--price,.m-price-item--sale");
          var priceElementGetPrice = target.closest(".shopify-section").querySelector(".m-add-to-cart--price") ? target.closest(".shopify-section").querySelector(".m-add-to-cart--price").getAttribute("data-price") : 0;
          if (document.getElementById("ppCheckbox").classList.contains("unchecked")) {
            container.classList.remove("subscription-select");
            container.classList.add("onetime-select");

            target
              .closest(".shopify-section")
              .querySelectorAll(".variant-price .subsription-price")
              .forEach((el) => (el.style.display = "none"));
            target
              .closest(".shopify-section")
              .querySelectorAll(".variant-price .main-price")
              .forEach((el) => (el.style.display = "block"));
            target
              .closest(".shopify-section")
              .querySelectorAll(".variant-price-per-day .per-day-subsription")
              .forEach((el) => (el.style.display = "none"));
            target
              .closest(".shopify-section")
              .querySelectorAll(".variant-price-per-day .per-day-onetime")
              .forEach((el) => (el.style.display = "block"));
            target
              .closest(".shopify-section")
              .querySelectorAll(".variant-bottom-text")
              .forEach((el) => (el.style.display = "none"));
            console.log("111");
          } else {
            container.classList.add("subscription-select");
            container.classList.remove("onetime-select");
            var priceElementQuantity = 1;
            if (target.closest(".m-product-option--node").querySelector(".top-title")) {
              var priceElementQuantity = target.closest(".m-product-option--node").querySelector(".top-title").innerText.split("")[0];
            }
            var minusPrice = 500 * Number(priceElementQuantity);

            target.closest(".shopify-section").classList.add("subscription_select");
            target
              .closest(".shopify-section")
              .querySelectorAll(".variant-price .subsription-price")
              .forEach((el) => (el.style.display = "block"));
            target
              .closest(".shopify-section")
              .querySelectorAll(".variant-price .main-price")
              .forEach((el) => (el.style.display = "none"));
            target
              .closest(".shopify-section")
              .querySelectorAll(".variant-price-per-day .per-day-subsription")
              .forEach((el) => (el.style.display = "block"));
            target
              .closest(".shopify-section")
              .querySelectorAll(".variant-price-per-day .per-day-onetime")
              .forEach((el) => (el.style.display = "none"));
            target
              .closest(".shopify-section")
              .querySelectorAll(".variant-bottom-text")
              .forEach((el) => (el.style.display = "block"));
            console.log("222");
          }
        }
      }
    });
  });
}

// Harrision Product page Subscription Text

const checkbox = document.getElementById("ppCheckbox");
let isChecked = true; // default is checked
document.addEventListener("DOMContentLoaded", (event) => {
  checkbox?.addEventListener("click", function () {
    isChecked = !isChecked;
    checkbox.classList.toggle("unchecked", !isChecked);

    const appCheckbox = document.querySelector(".loop-w-purchase-option-checkbox");
    const purchaseOption = document.querySelector(".loop-w-checkbox-purchase-option");

    const container = checkbox.closest(".m-main-product--info");
    var eleSalePrice = 0;
    var priceElementGetComparePrice = checkbox.closest(".shopify-section").querySelector(".m-add-to-cart-compare-price").getAttribute("data-price");
    var priceElement = checkbox.closest(".shopify-section").querySelectorAll(".m-add-to-cart--price,.m-price-item--sale");
    var priceElementGetPrice = checkbox.closest(".shopify-section").querySelector(".m-add-to-cart--price") ? checkbox.closest(".shopify-section").querySelector(".m-add-to-cart--price").getAttribute("data-price") : 0;

    var selected_value = checkbox.closest(".shopify-section").querySelector(".loop-w-btn-group-purchase-options-container .loop-w-btn-group-purchase-option.loop-w-btn-group-purchase-option-selected");

    if (selected_value) {
      if (selected_value.classList.contains("loop-w-btn-group-purchase-option-onetime")) {
        var discounted_custom_price = Number(document.querySelector(".m-product-option--node.active").getAttribute("data-price"));
        var discounted_custom_compare_price = Number(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"));
        document.querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart--price,.custom-product-price .price-item--sale").forEach((element) => {
          element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-price"), window.MinimogSettings.money_format);
        });
        if (discounted_custom_price == discounted_custom_compare_price) {
          document.querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart-compare-price,.custom-product-price .m-price-item--regular").forEach((element) => {
            element.style.display = "none";
            element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"), window.MinimogSettings.money_format);
          });
        } else {
          document.querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart-compare-price,.custom-product-price .m-price-item--regular").forEach((element) => {
            element.style.display = "block";
            element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"), window.MinimogSettings.money_format);
          });
        }
      } else {
        var discounted_custom_price = Number(document.querySelector(".m-product-option--node.active").getAttribute("data-subscription-price"));
        var discounted_custom_compare_price = Number(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"));
        document.querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart--price,.custom-product-price .price-item--sale").forEach((element) => {
          element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-subscription-price"), window.MinimogSettings.money_format);
        });
        if (discounted_custom_price == discounted_custom_compare_price) {
          document.querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart-compare-price,.custom-product-price .m-price-item--regular").forEach((element) => {
            element.style.display = "none";
            element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"), window.MinimogSettings.money_format);
          });
        } else {
          document.querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart-compare-price,.custom-product-price .m-price-item--regular").forEach((element) => {
            element.style.display = "block";
            element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"), window.MinimogSettings.money_format);
          });
        }
      }
    }

    document.querySelectorAll(".m-add-to-cart--price-wrapper.non-sub-price .m-add-to-cart--price").forEach((element) => {
      element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-price"), window.custom_formate_money_no_decimals);
    });
    
    // document.querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart-compare-price,.custom-product-price .m-price-item--regular").forEach(element => {
    //   element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"),window.MinimogSettings.money_format);
    // });
    if (document.querySelector(".custom-price__badge-sale .m-product-tag")) {
      let original_custom_price = Number(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"));
      const custom_discount = (((original_custom_price - discounted_custom_price) / original_custom_price) * 100).toFixed(0);
      document.querySelector(".custom-price__badge-sale .m-product-tag").innerHTML = `Sparen Sie ${custom_discount}%`;
    }

    if (appCheckbox || purchaseOption) {
      const isUnchecked = checkbox.classList.contains("unchecked");
      const isOptionSelected = purchaseOption.classList.contains("loop-widget-purchase-option-selected");
      const clickEvent = new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window,
      });
      appCheckbox.dispatchEvent(clickEvent);
    }

    const isUnchecked = checkbox.classList.contains("unchecked");

    if (isUnchecked) {
      const element = document.querySelector(".loop-w-btn-group-purchase-option.loop-w-btn-group-purchase-option-onetime");
      if (element) {
        const clickEvent = new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window,
        });

        element.dispatchEvent(clickEvent);
      }
      container.classList.remove("subscription-select");
      container.classList.add("onetime-select");

      var eleSalePrice = priceElementGetPrice;
      checkbox
        .closest(".shopify-section")
        .querySelectorAll(".variant-price .subsription-price")
        .forEach((el) => (el.style.display = "none"));
      checkbox
        .closest(".shopify-section")
        .querySelectorAll(".variant-price .main-price")
        .forEach((el) => (el.style.display = "block"));
      checkbox
        .closest(".shopify-section")
        .querySelectorAll(".variant-price-per-day .per-day-subsription")
        .forEach((el) => (el.style.display = "none"));
      checkbox
        .closest(".shopify-section")
        .querySelectorAll(".variant-price-per-day .per-day-onetime")
        .forEach((el) => (el.style.display = "block"));
      checkbox
        .closest(".shopify-section")
        .querySelectorAll(".variant-bottom-text")
        .forEach((el) => (el.style.display = "none"));

      // console.log('1');
      // var getPriceAtc = $('.m-add-to-cart--price').text();
      // var getComparePriceAtc = $('.m-add-to-cart-compare-price').text();
      var priceEl = document.querySelector(".m-add-to-cart--price");
      var comparePriceEl = document.querySelector(".m-add-to-cart-compare-price");
    } else {
      const element = document.querySelector(".loop-w-btn-group-purchase-option:not(.loop-w-btn-group-purchase-option-onetime)");
      if (element) {
        const clickEvent = new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window,
        });

        element.dispatchEvent(clickEvent);
      }
      container.classList.add("subscription-select");
      container.classList.remove("onetime-select");
      var priceElementQuantity = 1;
      if (checkbox.closest(".shopify-section").querySelector(".m-product-option--node.active .top-title")) {
        var priceElementQuantity = checkbox.closest(".shopify-section").querySelector(".m-product-option--node.active .top-title").getAttribute("data-variant-title").split("")[0];
      }
      var minusPrice = 500 * Number(priceElementQuantity);

      var eleSalePrice = Number(priceElementGetPrice) - minusPrice;
      checkbox.closest(".shopify-section").classList.add("subscription_select");
      checkbox
        .closest(".shopify-section")
        .querySelectorAll(".variant-price .subsription-price")
        .forEach((el) => (el.style.display = "block"));
      checkbox
        .closest(".shopify-section")
        .querySelectorAll(".variant-price .main-price")
        .forEach((el) => (el.style.display = "none"));
      checkbox
        .closest(".shopify-section")
        .querySelectorAll(".variant-price-per-day .per-day-subsription")
        .forEach((el) => (el.style.display = "block"));
      checkbox
        .closest(".shopify-section")
        .querySelectorAll(".variant-price-per-day .per-day-onetime")
        .forEach((el) => (el.style.display = "none"));
      checkbox
        .closest(".shopify-section")
        .querySelectorAll(".variant-bottom-text")
        .forEach((el) => (el.style.display = "block"));

      // console.log('2');
    }

    const getPR = getSavePercent(priceElementGetComparePrice, eleSalePrice);

    if (checkbox.closest(".shopify-section").querySelector("[data-saved-price]")) {
      checkbox.closest(".shopify-section").querySelector("[data-saved-price]").innerHTML = `${getPR}%`;
    }

    if (isChecked) {
      document.querySelectorAll("input[name='selling_plan']").forEach((input) => {
        input.disabled = false;
      });

      document.querySelectorAll(".subscri_text").forEach((text) => {
        text.style.display = "";
      });
      document.querySelectorAll(".normal_text").forEach((text) => {
        text.style.display = "none";
      });
      // Click on subscription plan (with data-selling-plan-group)
      const subscription = document.querySelector(".sls-option-container.seal-table[data-selling-plan-group]");
      if (subscription) subscription.click();
      if (document.querySelector(".more-gift-button")) {
        document.querySelector(".more-gift-button").closest(".gift-item").classList.remove("hidden");
      }
      document.querySelector(".hairrisson-shampoo .pp_var_autoship").classList.remove("autoship-disabled");
    } else {
      document.querySelectorAll("input[name='selling_plan']").forEach((input) => {
        input.disabled = true;
      });
      document.querySelectorAll(".normal_text").forEach((text) => {
        text.style.display = "";
      });
      document.querySelectorAll(".subscri_text").forEach((text) => {
        text.style.display = "none";
      });
      if (document.querySelector(".more-gift-button")) {
        document.querySelector(".more-gift-button").closest(".gift-item").classList.add("hidden");
      }
      document.querySelector(".hairrisson-shampoo .pp_var_autoship").classList.add("autoship-disabled");
      // Click on regular plan (without data-selling-plan-group)
      const regular = Array.from(document.querySelectorAll(".sls-option-container.seal-table")).find((el) => !el.hasAttribute("data-selling-plan-group"));
      if (regular) regular.click();
    }
    extraFreeProducts();
  });
});

function extraFreeProducts() {
  if (document.querySelectorAll(".main-product__block-free-product .gift-item").length) {
    const checkbox_subsruption = document.getElementById("ppCheckbox");
    var currentVariant = document.querySelector(".main-product__block-variant_picker input[type='radio']:checked").getAttribute("data-variant-title");
    console.log(currentVariant, "currentVariantcurrentVariant");
    var getselectedvariant = currentVariant.split("")[0];
    var variantStrToNum = Number(getselectedvariant);
    // var subscriptionIsActive = !checkbox_subsruption.classList.contains("unchecked");

    // Assume you already have these
    const variantname = variantStrToNum; // e.g. 1, 2, or 3
    const subscriptionIsActive = !checkbox_subsruption.classList.contains("unchecked");

    // Determine how many gifts are allowed based on logic
    let allowedGifts = 0;

    if (document.body.classList.contains("shape-harmonie-gummies")) {
      if (subscriptionIsActive) {
        if (variantname === 3 || variantname === 2) {
          allowedGifts = 4;
        } else if (variantname === 1) {
          allowedGifts = 4;
        }
      } else {
        if (variantname === 3) {
          allowedGifts = 2;
        } else if (variantname === 2) {
          allowedGifts = 1;
        } else {
          allowedGifts = 0;
        }
      }
    } else {
      if (subscriptionIsActive) {
        if (variantname === 3 || variantname === 2) {
          allowedGifts = 4;
        } else if (variantname === 1) {
          allowedGifts = 3;
        }
      } else {
        if (variantname === 3) {
          allowedGifts = 2;
        } else if (variantname === 2) {
          allowedGifts = 1;
        } else {
          allowedGifts = 0;
        }
      }
    }

    let addedGifts = 0;
    var freeProductId = "";
    const uniqueId = generateUniqueId();
    document.querySelectorAll(".main-product__block-free-product").forEach(rawItem => {
      rawItem.querySelectorAll(".main-product__block-free-product .gift-item").forEach((item) => {
        if (item.getAttribute("data-condition")) {
          
          const conditions = item.getAttribute("data-condition").split(",");

          // check if current gift item satisfies any valid condition
          let isValid = conditions.some((condition) => {
            const [qty, subType] = condition.split("-");
            const isSub = subType === "subscription" || subType === "subskrypcja" || subType === "subskrypcje" || subType === "abonamentowy";
            return parseInt(qty) === variantname && isSub === subscriptionIsActive;
          });

          if (isValid && (addedGifts < allowedGifts || document.body.classList.contains("horizon-variant-product"))) {
            item.classList.remove("is-unavailable");
            item.querySelector(".gift_card").classList.add("is-active");
            item.querySelector(".gift-overlay").classList.add("is-active");
            item.querySelectorAll("input[type='hidden']").forEach((input) => {
              input.removeAttribute("disabled");
            });
            freeProductId += "," + item.getAttribute("data-product-id");
            addedGifts++;
          } else {
            item.classList.add("is-unavailable");
            item.querySelector(".gift_card").classList.remove("is-active");
            item.querySelector(".gift-overlay").classList.remove("is-active");
            item.querySelectorAll("input[type='hidden']").forEach((input) => {
              input.setAttribute("disabled", "disabled");
            });
          }
        }
        // item.querySelector(".unique-id-child").value = uniqueId;
      });
    });

    const addToCartBtn = document.querySelector(".m-add-to-cart");
    const inputToRemove = document.querySelector("#custom_info");
    if (inputToRemove) {
      inputToRemove.remove();
    }

    if (addToCartBtn) {
      // Create a new hidden input
      // const hiddenInput = document.createElement('input');
      // hiddenInput.type = 'hidden';
      // hiddenInput.name = 'properties[_unique-id]';  // Change this to whatever name you need
      // hiddenInput.id = 'custom_info';  // Change this to whatever name you need
      // hiddenInput.value = uniqueId;  // Set your value here
      // // Insert it after the .m-add-to-cart element
      // addToCartBtn.insertAdjacentElement('afterend', hiddenInput);
    }
  }
}
extraFreeProducts();

async function getCart() {
  const res = await fetch("/cart.js");
  return res.json();
}

async function addFreeProduct() {
  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [
          {
            quantity: 1,
            id: window.FREE_PRODUCT_VARIANT_ID,
            properties: { _subProduct: true },
          },
        ],
      }),
    });

    const data = await response.json();

    const cartDrawer = document.querySelector("m-cart-drawer");
    if (cartDrawer) {
      cartDrawer.onCartDrawerUpdate(false);
    }

    return data;
  } catch (err) {
    console.error("Error adding free product:", err);
  }
}

async function updateFreeProductQty(lineItemKey, newQty) {
  try {
    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: lineItemKey,
        quantity: newQty,
      }),
    });

    const data = await response.json();

    const cartDrawer = document.querySelector("m-cart-drawer");
    if (cartDrawer) {
      cartDrawer.onCartDrawerUpdate(false);
    }
    const cartDrawerItems = document.querySelector("m-cart-drawer-items");
    if (cartDrawerItems) {
      cartDrawerItems.loading.finish();
    }

    return data;
  } catch (err) {
    console.error("Error updating free product quantity:", err);
  }
}

async function removeFreeProduct(lineItemKey) {
  return updateFreeProductQty(lineItemKey, 0);
}

async function syncFreeProduct(finish_function) {
  const cart = await getCart();
  const hasTrigger = cart.items.find((item) => item.product_id === window.TRIGGER_VARIANT_ID);
  const freeItem = cart.items.find((item) => item.variant_id === window.FREE_PRODUCT_VARIANT_ID);

  if (hasTrigger) {
    if (!freeItem) {
      console.log("Trigger found, free product not in cart – adding it...");
      await addFreeProduct();
    } else if (freeItem.quantity > 1) {
      const cartDrawerItems = document.querySelector("m-cart-drawer-items");
      if (cartDrawerItems) {
        cartDrawerItems.loading.start();
      }
      console.log("Free product in cart but has more than 1 quantity – reducing to 1...");
      await updateFreeProductQty(freeItem.key, 1, finish_function);
    } else {
      console.log("Free product is already in cart with correct quantity – all good.");
    }
  } else {
    if (freeItem) {
      console.log("Trigger removed – removing free product...");
      const cartDrawerItems = document.querySelector("m-cart-drawer-items");
      if (cartDrawerItems) {
        cartDrawerItems.loading.start();
      }
      await removeFreeProduct(freeItem.key);
    } else {
      console.log("No trigger, no free product – nothing to do.");
    }
  }
}

syncFreeProduct();

document.querySelectorAll('.m-add-to-cart[data-free-product="true"]').forEach(function (button) {
  button.addEventListener("click", function () {
    setTimeout(() => {
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: [
            {
              quantity: 1,
              id: window.FREE_PRODUCT_VARIANT_ID,
              properties: { _subProduct: true },
            },
          ],
        }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          // Update cart drawer if available
          var cartDrawer = document.querySelector("m-cart-drawer");
          if (cartDrawer) {
            cartDrawer.onCartDrawerUpdate(false);
          }
          syncFreeProduct();
          return data;
        })
        .catch(function (err) {
          console.error("Error adding free product:", err);
        });
    }, 500);
  });
});

// document.querySelectorAll(".main-product__block-variant_picker .m-product-option--node:nth-child(2) .m-product-option--node__label").forEach(variant => {
//   variant.dispatchEvent(new MouseEvent('click', { bubbles: true }));
// })

function setEqualHeight(selector) {
  const elements = document.querySelectorAll(selector);
  let maxHeight = 0;

  // Reset heights
  elements.forEach((el) => {
    el.style.height = "auto";
  });

  // Find the max height
  elements.forEach((el) => {
    if (el.offsetHeight > maxHeight) {
      maxHeight = el.offsetHeight;
    }
  });

  // Set all to max height
  elements.forEach((el) => {
    el.style.height = `${maxHeight}px`;
  });
}

setEqualHeight(".hairrisson-shampoo-subscription");

window.addEventListener("resize", () => {
  setEqualHeight(".hairrisson-shampoo-subscription");
});

async function updateMultipleQuantitiesByVariantIds(variantUpdates, qty) {
  // const updates = await getItemKeysByVariantIds(variantUpdates);
  console.log(variantUpdates, qty, "variantQtyMap");
  const updates = {};
  variantUpdates.forEach((k) => (updates[k] = qty));

  await fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ updates }),
  });

  var cartDrawer = document.querySelector("m-cart-drawer");
  if (cartDrawer) {
    cartDrawer.onCartDrawerUpdate(false);
  } else {
    window.location.reload();
  }
}

function generateUniqueId() {
  let id = Math.floor(100000000 + Math.random() * 900000000).toString();
  return id;
}

function cartCheck() {
  fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      const allItems = cart.items;

      // Check if all items have zero price
      const allAreFree =
        allItems.length > 0 &&
        allItems.every((item) => {
          return item.line_price === 0;
        });

      if (allAreFree) {
        // Clear the cart
        fetch("/cart/clear.js", {
          method: "POST",
        }).then(() => {
          var cartDrawer = document.querySelector("m-cart-drawer");
          if (cartDrawer) {
            cartDrawer.onCartDrawerUpdate(false);
            if (document.querySelector("m-cart-drawer-items")) {
              document.querySelector("m-cart-drawer-items").loading.finish();
            }
          } else {
            window.location.reload();
          }
        });
      }
    });
}
cartCheck();

function validateFreeGifts() {
  // fetch('/cart.js')
  //   .then(res => res.json())
  //   .then(cart => {
  //     let itemsToRemove = [];
  //     cart.items.forEach(item => {
  //       const price = item.final_line_price / 100; // price in store currency
  //       const uniqueId = item.properties && item.properties["_unique-id"] ? item.properties["_unique-id"] : null;
  //       // Free gift check
  //         if (price === 0) {
  //           let hasMatchingMainProduct = cart.items.some(otherItem => {
  //           return otherItem.properties &&
  //                  otherItem.properties["_unique-id"] &&
  //                  otherItem.properties["_unique-id"] === uniqueId &&
  //                  otherItem.final_line_price > 0; // main product price > 0
  //         });
  //         if (!hasMatchingMainProduct) {
  //           // mark this free gift for removal
  //           itemsToRemove.push(item.key);
  //         }
  //       }
  //     });
  //     if (itemsToRemove.length > 0) {
  //       removeInvalidFreeGifts(itemsToRemove);
  //     }else {
  //       window.location.href = "/checkout";
  //     }
  //   });
}

function removeInvalidFreeGifts(keys) {
  let updates = {};
  keys.forEach((key) => {
    updates[key] = 0; // remove
  });

  fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ updates }),
  }).then(() => {
    window.location.href = "/checkout";
  });
}

// document.querySelectorAll('[name="checkout"]').forEach(button => {
//     button.addEventListener("click", function(e) {
//       e.preventDefault();
//       this.classList.add("is-loading");
//         validateFreeGifts();
//     })
// })

function toggleDiscountVisibility(appliedDiscountCode) {
  const discountEl = document.querySelector(".applied-discount-wrapper");
  if (discountEl) {
    const targetCode = discountEl.dataset.discountCode;
    console.log(appliedDiscountCode, "appliedDiscountCodeappliedDiscountCode");
    if (appliedDiscountCode && appliedDiscountCode.toLowerCase() === targetCode.toLowerCase()) {
      discountEl.removeAttribute("hidden");
    } else {
      discountEl.setAttribute("hidden", "");
    }
  }
}

function cartPreStruc(selector) {
  selector.insertAdjacentHTML(
    "afterbegin",
    `
    <div class="styles_skeleton__ upcart-product-item-skeleton upcart-skeleton" 
         style="display: flex; flex-direction: row; gap: 30px; justify-content: space-between;padding: 10px;padding-top: 0;">
      <div class="styles_imageLarge__ upcart-product-image-skeleton styles_shimmer__"></div>
      <div style="display: flex; flex-direction: column; justify-content: space-between; flex-grow: 1;">
        <div style="display: flex; flex-direction: column; gap: 8px;">
          <div class="styles_shimmer__ upcart-product-title-skeleton styles_textLarge__"></div>
          <div class="styles_shimmer__ upcart-item-option-skeleton styles_textSmall__" style="width: 70%;"></div>
        </div>
        <div class="styles_shimmer__ upcart-product-quantity-skeleton" style="width: 50%; height: 30px;"></div>
      </div>
      <div class="upcart-product-price-container-skeleton" 
           style="width: 25%; display: flex; flex-direction: column; gap: 8px; justify-content: flex-end; align-items: flex-end;">
        <div class="styles_shimmer__ styles_textMedium__" style="width: 100%;"></div>
        <div class="styles_shimmer__ styles_textMedium__" style="width: 100%;"></div>
        <div class="styles_shimmer__ styles_textMedium__" style="width: 80%;"></div>
        <div class="styles_shimmer__"></div>
      </div>
    </div>
  `,
  );
}

function setEHeight() {
  // Check screen size
  if (window.innerWidth < 768) {
    // Agar screen chhoti hai to height reset kar do
    document.querySelectorAll(".custom-icon-text-item .custom-icon-img, .custom-icon-text-item h2").forEach((el) => (el.style.height = "auto"));
    return;
  }

  // Common function to set equal height for given selector
  const setEqualHeight = (selector) => {
    let heightArr = [];
    const elements = document.querySelectorAll(selector);

    if (!elements.length) return; // agar element hi na mile to return

    elements.forEach((element) => {
      element.style.height = "auto"; // reset height pehle
      heightArr.push(element.offsetHeight);
    });

    const maxHeight = Math.max(...heightArr);
    elements.forEach((element) => {
      element.style.height = maxHeight + "px";
    });
  };

  // Call for both selectors

  setEqualHeight(".wie-wirkt-femipore .custom-icon-text-item .custom-icon-img");
  setEqualHeight(".wie-wirkt-femipore .custom-icon-text-item h2");
  setEqualHeight(".wie-wirkt-femipore .custom-icon-text-item .custom-icon-text-detail");
  setEqualHeight(".wie-wirkt-femipore .custom-icon-text-item .custom-icon-text-button");
}

setEHeight();

// Responsive ke liye window resize pe bhi call kar do
window.addEventListener("resize", setEHeight);

document.querySelectorAll(".upsell-product").forEach((item) => {
  item.querySelector(".upsell-learn-btn")?.addEventListener("click", function () {
    this.closest(".upsell-product").querySelector(".upsell-modal").classList.add("active");
    document.documentElement.classList.add("prevent-scroll");
  });
});

document.addEventListener("click", (e) => {
  // check if clicked element OR its parent has the close button class
  if (e.target.closest(".upsell-btn--close")) {
    const modal = e.target.closest(".upsell-modal");
    if (modal) {
      modal.classList.remove("active");
      document.documentElement.classList.remove("prevent-scroll");
    }
  }
  const modal = e.target.closest(".upsell-modal");
  if (modal && e.target === modal) {
    modal.classList.remove("active");
    document.documentElement.classList.remove("prevent-scroll");
  }
});

document.querySelectorAll(".toltip-wrapper").forEach((wrapper) => {
  const tip = wrapper.querySelector(".toltip-content");

  wrapper.addEventListener("mouseenter", () => {
    // 1) Make tooltip visible FIRST (temporarily)
    tip.style.opacity = "0";
    tip.style.visibility = "visible";

    // Wait 10ms so browser can calculate actual width
    requestAnimationFrame(() => {
      // Reset properties for clean calculation
      tip.style.left = "50%";
      tip.style.right = "auto";
      tip.style.transform = "translateX(-50%)";

      const rect = tip.getBoundingClientRect();

      // 2) If overflow left
      if (rect.left < 0) {
        tip.style.left = "-10px";
        tip.style.transform = "translateX(0)";
      }

      // 3) If overflow right
      if (rect.right > window.innerWidth) {
        tip.style.left = "auto";
        tip.style.right = "-10px";
        tip.style.transform = "translateX(0)";
      }

      // 4) Now make tooltip fully visible
      tip.style.opacity = "1";
    });
  });

  wrapper.addEventListener("mouseleave", () => {
    tip.style.opacity = "";
    tip.style.visibility = "";
    tip.style.left = "";
    tip.style.right = "";
    tip.style.transform = "";
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('a[href="#top"]').forEach(function (btn) {
    btn.addEventListener("click", function () {
      // wait for the #top jump to finish
      setTimeout(function () {
        const target = document.querySelector(".main-product__block-price");
        if (!target) return;

        target.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100);
    });
  });
});

// Custom review slider
document.querySelectorAll(".section-custom-review-slider").forEach((section) => {
  const slider = section.querySelector(".review-card-main");

  const enableAutoplay = slider.dataset.autoplay === "true";
  const autoplayDelay = parseInt(slider.dataset.autoplayDelay) || 3000;

  new Swiper(slider, {
    slidesPerView: 1.3,
    spaceBetween: 12,
    loop: true,
    centeredSlides: true,

    navigation: {
      nextEl: section.querySelector(".swiper-button-next"),
      prevEl: section.querySelector(".swiper-button-prev"),
    },

    autoplay: enableAutoplay
      ? {
          delay: autoplayDelay,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }
      : false,

    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1080: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
    },
  });
});

document.querySelectorAll(".image-with-text-slider").forEach((section) => {
  const imageSlider = section.querySelector(".image-and-text-main");

  const enableAutoplay = imageSlider.dataset.autoplay === "true";
  const autoplayDelay = parseInt(imageSlider.dataset.autoplayDelay) || 3000;

  new Swiper(imageSlider, {
    slidesPerView: 1.3,
    spaceBetween: 12,
    loop: true,
    centeredSlides: true,
    watchSlidesProgress: true,

    navigation: {
      nextEl: section.querySelector(".swiper-button-next"),
      prevEl: section.querySelector(".swiper-button-prev"),
    },

    autoplay: enableAutoplay
      ? {
          delay: autoplayDelay,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }
      : false,

    breakpoints: {
      768: {
        slidesPerView: 2.5,
        spaceBetween: 20,
      },
      1080: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
    },
    on: {
      init: function () {
        window.dispatchEvent(new Event('resize'));
      },
      slideChange: function () {
        window.dispatchEvent(new Event('resize'));
      },
    },
  });
});

function equalHeight(selector) {
  const elements = document.querySelectorAll(selector);
  if (!elements.length) return;

  // Reset heights
  elements.forEach((el) => {
    el.style.height = "auto";
  });

  // Find tallest
  let maxHeight = 0;
  elements.forEach((el) => {
    const height = el.offsetHeight;
    if (height > maxHeight) {
      maxHeight = height;
    }
  });

  // Apply tallest height
  elements.forEach((el) => {
    el.style.height = maxHeight + "px";
  });
}

// Run on load
window.addEventListener("load", function () {
  equalHeight(".image-with-text-slider .image-and-text-wrapper .image-and-text-content");
});
document.addEventListener("DOMContentLoaded", function () {
  equalHeight(".image-with-text-slider .image-and-text-wrapper .image-and-text-content");
});

// Run on resize
window.addEventListener("resize", function () {
  equalHeight(".image-with-text-slider .image-and-text-wrapper .image-and-text-content");
});

function renderText(template, amount) {
  return template.replace("[amount]", amount);
}

function escHtml(str) {
  return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}

// ── Check if gift is already in cart via /cart.js ──
function checkGiftInCart(giftVariantId) {
  return fetch("/cart.js")
    .then(function (r) {
      return r.json();
    })
    .then(function (cart) {
      return cart.items.some(function (item) {
        return item.variant_id === giftVariantId && item.properties && item.properties["_free_gift"] === "true";
      });
    });
}

// ── Add free gift ──────────────────────────────
function addGift(giftVariantId, giftBusy) {
  if (!giftVariantId || giftBusy) return;
  giftBusy = true;

  var cartDrawer = document.querySelector("m-cart-drawer");
  if (cartDrawer) {
    if (document.querySelector("m-cart-drawer-items")) {
      document.querySelector("m-cart-drawer-items").loading.start();
    }
  }

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: giftVariantId,
      quantity: 1,
      properties: { _free_gift: "true" },
    }),
  })
    .then(function (r) {
      return r.json();
    })
    .then(function () {
      const cartDrawer = document.querySelector("m-cart-drawer");
      if (cartDrawer) {
        if (document.querySelector("m-cart-drawer-items")) {
          document.querySelector("m-cart-drawer-items").loading.finish();
        }
        cartDrawer.onCartDrawerUpdate(false);
      }
    })
    .catch(function (err) {
      console.warn("[CPB] Could not add free gift:", err);
      const cartDrawer = document.querySelector("m-cart-drawer");
      if (cartDrawer) {
        if (document.querySelector("m-cart-drawer-items")) {
          document.querySelector("m-cart-drawer-items").loading.finish();
        }
      }
    })
    .finally(function () {
      giftBusy = false;
      const cartDrawer = document.querySelector("m-cart-drawer");
      if (cartDrawer) {
        if (document.querySelector("m-cart-drawer-items")) {
          document.querySelector("m-cart-drawer-items").loading.finish();
        }
      }
    });
}

// ── Remove free gift ───────────────────────────
function removeGift(giftVariantId, giftBusy, giftInCart) {
  if (!giftVariantId || giftBusy) return;
  giftBusy = true;

  var cartDrawer = document.querySelector("m-cart-drawer");
  if (cartDrawer) {
    if (document.querySelector("m-cart-drawer-items")) {
      document.querySelector("m-cart-drawer-items").loading.start();
    }
  }

  // Find the line item key for this gift variant
  fetch("/cart.js")
    .then(function (r) {
      return r.json();
    })
    .then(function (cart) {
      const giftItem = cart.items.find(function (item) {
        return item.variant_id === giftVariantId && item.properties && item.properties["_free_gift"] === "true";
      });
      if (!giftItem) {
        giftInCart = false;
        giftBusy = false;
        return;
      }
      return fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: giftItem.key, quantity: 0 }),
      });
    })
    .then(function () {
      giftInCart = false;
      const cartDrawer = document.querySelector("m-cart-drawer");
      if (cartDrawer) {
        cartDrawer.onCartDrawerUpdate(false);
        if (document.querySelector("m-cart-drawer-items")) {
          document.querySelector("m-cart-drawer-items").loading.finish();
        }
      }
    })
    .catch(function (err) {
      const cartDrawer = document.querySelector("m-cart-drawer");
      if (cartDrawer) {
        if (document.querySelector("m-cart-drawer-items")) {
          document.querySelector("m-cart-drawer-items").loading.finish();
        }
      }
      console.warn("[CPB] Could not remove free gift:", err);
    })
    .finally(function () {
      giftBusy = false;
      const cartDrawer = document.querySelector("m-cart-drawer");
      if (cartDrawer) {
        if (document.querySelector("m-cart-drawer-items")) {
          document.querySelector("m-cart-drawer-items").loading.finish();
        }
      }
    });
}


window.dispatchEvent(new Event('resize'));
document.addEventListener("DOMContentLoaded", (event) => {
  window.dispatchEvent(new Event('resize'));
});
window.addEventListener('load', (event) => {
  window.dispatchEvent(new Event('resize'));
});

document.querySelectorAll('.frontrow-accordion__trigger').forEach((trigger) => {
  trigger.addEventListener('click', (event) => {
    event.currentTarget
      .closest('.frontrow-accordion__item')
      .classList.toggle('is-open');
  });
});